














// "use client";

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, Paper, TextField, Select, MenuItem,
//   FormControl, InputLabel, Chip, IconButton, Dialog,
//   DialogTitle, DialogContent, CircularProgress, Grid,
//   Card, CardContent, Divider, Tooltip, InputAdornment,
//   Button, Avatar, Badge,
// } from "@mui/material";
// import SendIcon        from "@mui/icons-material/Send";
// import SearchIcon      from "@mui/icons-material/Search";
// import RefreshIcon     from "@mui/icons-material/Refresh";
// import CloseIcon       from "@mui/icons-material/Close";
// import FolderOpenIcon  from "@mui/icons-material/FolderOpen";
// import HeadsetMicIcon  from "@mui/icons-material/HeadsetMic";
// import PersonIcon      from "@mui/icons-material/Person";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import HistoryIcon     from "@mui/icons-material/History";
// import Swal            from "sweetalert2";
// import { Url }         from "src/url/url";
// import { io as socketIo } from "socket.io-client";

// // ─── Color maps ──────────────────────────────────────────────────────────────
// const STATUS_COLOR    = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
// const PRIORITY_COLOR  = { high: "error", medium: "warning", low: "success" };

// // ─── Ticket Chat ─────────────────────────────────────────────────────────────
// const TicketChat = ({ ticket, onUpdate }) => {
//   const [replyText, setReplyText] = useState("");
//   const [sending,   setSending]   = useState(false);
//   const chatEndRef                = useRef(null);
//   const isClosed = ticket.status === "closed";

//   useEffect(() => {
//     setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
//   }, [ticket.messages?.length]);

//   const handleReply = async () => {
//     if (!replyText.trim() || sending) return;
//     setSending(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         setReplyText("");
//         onUpdate(data.ticket);
//       }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." });
//     } finally {
//       setSending(false);
//     }
//   };

//   const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

//   return (
//     <Box>
//       {/* Messages area */}
//       <Box sx={{
//         height: 340, overflowY: "auto", background: "#f5f7fa",
//         px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5,
//       }}>
//         {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
//           const isAdmin  = msg.sender === "admin";
//           const isSystem = msg.senderName === "System";
//           if (isSystem) {
//             return (
//               <Box key={i} sx={{ textAlign: "center" }}>
//                 <Typography
//                   variant="caption"
//                   sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}
//                 >
//                   {msg.message}
//                 </Typography>
//               </Box>
//             );
//           }
//           return (
//             <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
//               {!isAdmin && (
//                 <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                   {(msg.senderName || "C").charAt(0).toUpperCase()}
//                 </Avatar>
//               )}
//               <Box sx={{ maxWidth: "74%" }}>
//                 {!isAdmin && (
//                   <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>
//                     {msg.senderName}
//                   </Typography>
//                 )}
//                 <Box sx={{
//                   px: 2, py: 1.5, borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
//                   bgcolor: isAdmin ? "#1976d2" : "#fff",
//                   color: isAdmin ? "#fff" : "inherit",
//                   border: !isAdmin ? "1px solid #e0e0e0" : "none",
//                   boxShadow: 1,
//                 }}>
//                   <Typography variant="body2">{msg.message}</Typography>
//                   <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>
//                     {fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           );
//         })}
//         <div ref={chatEndRef} />
//       </Box>

//       <Divider />

//       {/* Reply box */}
//       {isClosed ? (
//         <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
//           <Typography variant="caption" color="text.secondary">
//             🔒 Ticket closed. Status change karo to reply kar sako.
//           </Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
//           <TextField
//             fullWidth size="small"
//             placeholder="Client ko reply karein..."
//             value={replyText}
//             onChange={(e) => setReplyText(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()}
//             sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
//           />
//           <IconButton
//             color="primary" onClick={handleReply}
//             disabled={!replyText.trim() || sending}
//             sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}
//           >
//             <SendIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// // MAIN ADMIN COMPONENT
// // ════════════════════════════════════════════════════════════════════════════
// const AdminHelpSupport = () => {
//   const [tickets,        setTickets]        = useState([]);
//   const [filtered,       setFiltered]       = useState([]);
//   const [activeTicket,   setActiveTicket]   = useState(null);
//   const [filterStatus,   setFilterStatus]   = useState("all");
//   const [filterPriority, setFilterPriority] = useState("all");
//   const [search,         setSearch]         = useState("");
//   const [loading,        setLoading]        = useState(true);

//   // Assign modal state
//   const [showAssign,    setShowAssign]    = useState(false);
//   const [staffList,     setStaffList]     = useState([]);   // ✅ always []
//   const [assignForm,    setAssignForm]    = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//   const [assigning,     setAssigning]     = useState(false);

//   // Escalation log dialog
//   const [showLog,       setShowLog]       = useState(false);

//   const socketRef = useRef(null);

//   // ── Socket.IO ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     const socket = socketIo(Url, { transports: ["websocket"] });
//     socketRef.current = socket;

//     const adminToken = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
//     if (adminToken) socket.emit("joinAdmin", adminToken);

//     socket.on("support:new_ticket", (ticket) => {
//       setTickets((prev) => [ticket, ...prev]);
//       Swal.fire({
//         toast: true, position: "top-end", icon: "info", showConfirmButton: false,
//         timer: 4000, title: `New Ticket: #${ticket.ticketId}`,
//         text: ticket.subject,
//       });
//     });

//     socket.on("support:ticket_updated", (updated) => {
//       setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//       setActiveTicket((prev) => (prev?._id === updated._id ? updated : prev));
//     });

//     socket.on("support:ticket_deleted", ({ ticketId }) => {
//       setTickets((prev) => prev.filter((t) => t._id !== ticketId));
//       setActiveTicket((prev) => (prev?._id === ticketId ? null : prev));
//     });

//     socket.on("support:new_message", ({ ticketCode }) => {
//       Swal.fire({
//         toast: true, position: "top-end", icon: "success", showConfirmButton: false,
//         timer: 2500, title: `New reply on ${ticketCode}`,
//       });
//     });

//     // ✅ FIX 1: null check before disconnect
//     return () => {
//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }
//     };
//   }, []);

//   // ── Fetch Tickets ─────────────────────────────────────────────────────
//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets`);
//       const data = await res.json();
//       if (res.ok) {
//         // ✅ FIX: ensure array
//         const list = Array.isArray(data.tickets) ? data.tickets : [];
//         setTickets(list);
//         setFiltered(list);
//       }
//     } catch { console.error("Failed to fetch tickets"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchTickets(); }, [fetchTickets]);

//   // ── Fetch Management Staff ────────────────────────────────────────────
//   // ✅ FIX 2: Always set an array, handle all response shapes
//   const fetchStaffList = async () => {
//     try {
//       const res  = await fetch(`${Url}/management-staff`);
//       const data = await res.json();
//       if (res.ok) {
//         // Handle: { staff: [] } or { data: [] } or plain array []
//         const raw = data.staff ?? data.data ?? data ?? [];
//         setStaffList(Array.isArray(raw) ? raw : []);
//       } else {
//         setStaffList([]);
//       }
//     } catch (err) {
//       console.error("Staff fetch failed", err);
//       setStaffList([]); // ✅ always fallback to []
//     }
//   };

//   // ── Filter ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let result = [...tickets];
//     if (filterStatus   !== "all") result = result.filter((t) => t.status === filterStatus);
//     if (filterPriority !== "all") result = result.filter((t) => t.priority === filterPriority);
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       result = result.filter((t) =>
//         t.ticketId?.toLowerCase().includes(q) ||
//         t.subject?.toLowerCase().includes(q) ||
//         t.clientName?.toLowerCase().includes(q) ||
//         t.projectId?.toLowerCase().includes(q)
//       );
//     }
//     setFiltered(result);
//   }, [filterStatus, filterPriority, search, tickets]);

//   // ── Status Update ─────────────────────────────────────────────────────
//   const handleStatusChange = async (ticketId, status) => {
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ status }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//       }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Status update failed." });
//     }
//   };

//   // ── Assign Ticket ─────────────────────────────────────────────────────
//   const handleAssign = async () => {
//     if (!assignForm.staffId || !activeTicket) return;
//     setAssigning(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           staffId:   assignForm.staffId,
//           staffName: assignForm.staffName,
//           staffRole: assignForm.staffRole,
//           reason:    assignForm.reason,
//           adminName: "Admin",
//         }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false });
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//         setShowAssign(false);
//         setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//       } else {
//         Swal.fire({ icon: "error", title: "Error", text: data.message });
//       }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." });
//     } finally {
//       setAssigning(false);
//     }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.",
//       icon: "warning", showCancelButton: true,
//       confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f",
//     });
//     if (!confirm.isConfirmed) return;
//     try {
//       await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" });
//       setTickets((prev) => prev.filter((t) => t._id !== id));
//       setActiveTicket(null);
//     } catch { /* silent */ }
//   };

//   const formatDate = (d) =>
//     new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });

//   const stats = [
//     { label: "Total",       value: tickets.length,                                            color: "#1976d2", bg: "#e3f2fd" },
//     { label: "Open",        value: tickets.filter((t) => t.status === "open").length,          color: "#f57c00", bg: "#fff3e0" },
//     { label: "In Progress", value: tickets.filter((t) => t.status === "in-progress").length,   color: "#0288d1", bg: "#e1f5fe" },
//     { label: "Resolved",    value: tickets.filter((t) => t.status === "resolved").length,      color: "#388e3c", bg: "#e8f5e9" },
//   ];

//   return (
//     <Box sx={{ p: 3 }}>
//       {/* Header */}
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
//           <HeadsetMicIcon color="primary" /> Help & Support Tickets
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Manage and assign client support requests
//         </Typography>
//       </Box>

//       {/* Stats */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {stats.map((s) => (
//           <Grid item xs={6} md={3} key={s.label}>
//             <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
//               <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
//                 <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
//                 <Typography variant="body2" color="text.secondary">{s.label}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Filters */}
//       <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
//         <TextField
//           size="small" placeholder="Search ticket, client, project..."
//           value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: 260 }}
//           InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
//         />
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Status</InputLabel>
//           <Select label="Status" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//             <MenuItem value="all">All Status</MenuItem>
//             <MenuItem value="open">Open</MenuItem>
//             <MenuItem value="in-progress">In Progress</MenuItem>
//             <MenuItem value="resolved">Resolved</MenuItem>
//             <MenuItem value="closed">Closed</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Priority</InputLabel>
//           <Select label="Priority" value={filterPriority} onChange={(e) => setFilterPriority(e.target.value)}>
//             <MenuItem value="all">All Priority</MenuItem>
//             <MenuItem value="high">High</MenuItem>
//             <MenuItem value="medium">Medium</MenuItem>
//             <MenuItem value="low">Low</MenuItem>
//           </Select>
//         </FormControl>
//         <Tooltip title="Refresh">
//           <IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton>
//         </Tooltip>
//       </Box>

//       {/* Table */}
//       {loading ? (
//         <Box sx={{ textAlign: "center", py: 8 }}>
//           <CircularProgress />
//           <Typography mt={2} color="text.secondary">Loading tickets...</Typography>
//         </Box>
//       ) : filtered.length === 0 ? (
//         <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
//           <FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} />
//           <Typography>No tickets found.</Typography>
//         </Box>
//       ) : (
//         <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
//           <Box sx={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ background: "#f5f5f5" }}>
//                   {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map((h) => (
//                     <th key={h} style={{
//                       padding: "12px 14px", textAlign: "left", fontWeight: 600,
//                       whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555",
//                     }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((ticket, idx) => (
//                   <tr
//                     key={ticket._id}
//                     style={{ background: idx % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer" }}
//                     onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
//                     onMouseLeave={(e) => (e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#fafafa")}
//                   >
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Typography variant="caption" fontWeight={700} color="primary">
//                         #{ticket.ticketId}
//                       </Typography>
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
//                       <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography>
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}>
//                       <Typography variant="body2" noWrap>
//                         {ticket.subject === "Other" ? ticket.customSubject : ticket.subject}
//                       </Typography>
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       {ticket.assignedTo?.id ? (
//                         <Box display="flex" alignItems="center" gap={0.5}>
//                           <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                             {ticket.assignedTo.name?.charAt(0)}
//                           </Avatar>
//                           <Typography variant="caption">{ticket.assignedTo.name}</Typography>
//                         </Box>
//                       ) : (
//                         <Typography variant="caption" color="text.secondary">Unassigned</Typography>
//                       )}
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
//                       <Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography>
//                     </td>
//                     <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                       <Box display="flex" gap={0.5}>
//                         <button
//                           className="btn btn-primary btn-sm"
//                           style={{ fontSize: 11 }}
//                           onClick={() => { setActiveTicket(ticket); setShowAssign(false); setShowLog(false); }}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="btn btn-outline-danger btn-sm"
//                           style={{ fontSize: 11 }}
//                           onClick={() => handleDelete(ticket._id)}
//                         >
//                           Del
//                         </button>
//                       </Box>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Ticket Detail Dialog ─────────────────────────────────────────── */}
//       <Dialog open={!!activeTicket} onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }} maxWidth="md" fullWidth>
//         {activeTicket && (
//           <>
//             <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
//                 <Typography variant="h6" fontWeight={700}>
//                   {activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}
//                 </Typography>
//               </Box>
//               <Box display="flex" gap={1}>
//                 <Tooltip title="Escalation Log">
//                   <IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small">
//                     <HistoryIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Assign to Staff">
//                   <IconButton
//                     onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }}
//                     size="small" color="primary"
//                   >
//                     <AssignmentIndIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }} size="small">
//                   <CloseIcon />
//                 </IconButton>
//               </Box>
//             </DialogTitle>
//             <Divider />

//             {/* Info Bar */}
//             <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 <Typography variant="caption"><b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}</Typography>
//               </Box>
//               <Typography variant="caption" color="text.secondary">
//                 Project: <b>{activeTicket.projectName || activeTicket.projectId}</b>
//               </Typography>
//               <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />

//               {activeTicket.assignedTo?.id && (
//                 <Box display="flex" alignItems="center" gap={0.5}>
//                   <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
//                   <Typography variant="caption" color="primary">
//                     <b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})
//                   </Typography>
//                 </Box>
//               )}

//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select
//                   value={activeTicket.status}
//                   onChange={(e) => handleStatusChange(activeTicket._id, e.target.value)}
//                   sx={{ fontSize: "12px", height: "28px" }}
//                 >
//                   <MenuItem value="open">Open</MenuItem>
//                   <MenuItem value="in-progress">In Progress</MenuItem>
//                   <MenuItem value="resolved">Resolved</MenuItem>
//                   <MenuItem value="closed">Closed</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <DialogContent sx={{ p: 0 }}>
//               {/* Assign Panel */}
//               {showAssign && (
//                 <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
//                     <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Assign Ticket to Management Staff
//                   </Typography>
//                   <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
//                     <FormControl size="small" sx={{ minWidth: 200 }}>
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         label="Select Staff"
//                         value={assignForm.staffId}
//                         onChange={(e) => {
//                           const s = staffList.find((x) => x._id === e.target.value);
//                           setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" });
//                         }}
//                       >
//                         <MenuItem value="">-- Select --</MenuItem>
//                         {/* ✅ FIX: staffList.map is safe because we always ensure it's an array */}
//                         {staffList.map((s) => (
//                           <MenuItem key={s._id} value={s._id}>
//                             {s.name} ({s.roleName || s.slug || "staff"})
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                       <InputLabel>Role</InputLabel>
//                       <Select
//                         label="Role"
//                         value={assignForm.staffRole}
//                         onChange={(e) => setAssignForm({ ...assignForm, staffRole: e.target.value })}
//                       >
//                         <MenuItem value="staff">Staff</MenuItem>
//                         <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
//                       </Select>
//                     </FormControl>
//                     <TextField
//                       size="small" label="Reason (optional)"
//                       value={assignForm.reason}
//                       onChange={(e) => setAssignForm({ ...assignForm, reason: e.target.value })}
//                       sx={{ minWidth: 180 }}
//                     />
//                     <Button
//                       variant="contained" size="small"
//                       onClick={handleAssign}
//                       disabled={!assignForm.staffId || assigning}
//                       startIcon={<AssignmentIndIcon />}
//                     >
//                       {assigning ? "Assigning..." : "Assign"}
//                     </Button>
//                     <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
//                   </Box>
//                 </Box>
//               )}

//               {/* Escalation Log Panel */}
//               {showLog && (
//                 <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1}>
//                     <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Escalation Log
//                   </Typography>
//                   {!activeTicket.escalationLog?.length ? (
//                     <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
//                   ) : (
//                     activeTicket.escalationLog.map((log, i) => (
//                       <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
//                         <b>{log.fromName}</b> → <b>{log.toName}</b>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                           {log.reason || "N/A"} · {formatDate(log.escalatedAt)}
//                         </Typography>
//                       </Box>
//                     ))
//                   )}
//                 </Box>
//               )}

//               {/* Chat */}
//               <TicketChat
//                 ticket={activeTicket}
//                 onUpdate={(updated) => {
//                   setActiveTicket(updated);
//                   setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//                 }}
//               />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminHelpSupport;












// "use client";

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, Paper, TextField, Select, MenuItem,
//   FormControl, InputLabel, Chip, IconButton, Dialog,
//   DialogTitle, DialogContent, CircularProgress, Grid,
//   Card, CardContent, Divider, Tooltip, InputAdornment,
//   Button, Avatar,
// } from "@mui/material";
// import SendIcon          from "@mui/icons-material/Send";
// import SearchIcon        from "@mui/icons-material/Search";
// import RefreshIcon       from "@mui/icons-material/Refresh";
// import CloseIcon         from "@mui/icons-material/Close";
// import FolderOpenIcon    from "@mui/icons-material/FolderOpen";
// import HeadsetMicIcon    from "@mui/icons-material/HeadsetMic";
// import PersonIcon        from "@mui/icons-material/Person";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import HistoryIcon       from "@mui/icons-material/History";
// import Swal              from "sweetalert2";
// import { Url }           from "src/url/url";
// import { io as socketIo } from "socket.io-client";

// const STATUS_COLOR   = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
// const PRIORITY_COLOR = { high: "error", medium: "warning", low: "success" };

// // ── Unread dot badge ──────────────────────────────────────────────────────────
// const UnreadDot = ({ count }) => {
//   if (!count || count <= 0) return null;
//   return (
//     <span style={{
//       background: "#f44336", color: "#fff", borderRadius: 50,
//       padding: "1px 7px", fontSize: 10, fontWeight: 700,
//       display: "inline-flex", alignItems: "center", justifyContent: "center",
//       marginLeft: 6, animation: "adminPulse 1.5s ease infinite",
//     }}>
//       {count > 99 ? "99+" : count}
//     </span>
//   );
// };

// // ─── Ticket Chat ──────────────────────────────────────────────────────────────
// const TicketChat = ({ ticket, onUpdate, onMarkRead }) => {
//   const [replyText, setReplyText] = useState("");
//   const [sending,   setSending]   = useState(false);
//   const chatEndRef                = useRef(null);
//   const isClosed = ticket.status === "closed";

//   useEffect(() => { setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80); }, [ticket.messages?.length]);

//   // Mark as read when chat opens
//   useEffect(() => {
//     if (ticket?._id && (ticket?.unreadByAdmin || 0) > 0) onMarkRead?.(ticket._id);
//   }, [ticket?._id]);

//   const handleReply = async () => {
//     if (!replyText.trim() || sending) return;
//     setSending(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
//         method: "POST", headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
//       });
//       const data = await res.json();
//       if (res.ok) { setReplyText(""); onUpdate(data.ticket); }
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." }); }
//     finally { setSending(false); }
//   };

//   const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

//   return (
//     <Box>
//       <Box sx={{ height: 340, overflowY: "auto", background: "#f5f7fa", px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
//         {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
//           const isAdmin  = msg.sender === "admin";
//           const isSystem = msg.senderName === "System";
//           if (isSystem) return (
//             <Box key={i} sx={{ textAlign: "center" }}>
//               <Typography variant="caption" sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}>{msg.message}</Typography>
//             </Box>
//           );
//           return (
//             <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
//               {!isAdmin && <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>{(msg.senderName || "C").charAt(0).toUpperCase()}</Avatar>}
//               <Box sx={{ maxWidth: "74%" }}>
//                 {!isAdmin && <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>{msg.senderName}</Typography>}
//                 <Box sx={{ px: 2, py: 1.5, borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px", bgcolor: isAdmin ? "#1976d2" : "#fff", color: isAdmin ? "#fff" : "inherit", border: !isAdmin ? "1px solid #e0e0e0" : "none", boxShadow: 1 }}>
//                   <Typography variant="body2">{msg.message}</Typography>
//                   <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>{fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}</Typography>
//                 </Box>
//               </Box>
//             </Box>
//           );
//         })}
//         <div ref={chatEndRef} />
//       </Box>
//       <Divider />
//       {isClosed ? (
//         <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
//           <Typography variant="caption" color="text.secondary">🔒 Ticket closed.</Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
//           <TextField fullWidth size="small" placeholder="Client ko reply karein..." value={replyText} onChange={(e) => setReplyText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()} sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }} />
//           <IconButton color="primary" onClick={handleReply} disabled={!replyText.trim() || sending} sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}>
//             <SendIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// // MAIN ADMIN COMPONENT
// // ════════════════════════════════════════════════════════════════════════════
// const AdminHelpSupport = () => {
//   const [tickets,        setTickets]        = useState([]);
//   const [filtered,       setFiltered]       = useState([]);
//   const [activeTicket,   setActiveTicket]   = useState(null);
//   const [filterStatus,   setFilterStatus]   = useState("all");
//   const [filterPriority, setFilterPriority] = useState("all");
//   const [search,         setSearch]         = useState("");
//   const [loading,        setLoading]        = useState(true);
//   const [showAssign,     setShowAssign]     = useState(false);
//   const [staffList,      setStaffList]      = useState([]);
//   const [assignForm,     setAssignForm]     = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//   const [assigning,      setAssigning]      = useState(false);
//   const [showLog,        setShowLog]        = useState(false);

//   const socketRef = useRef(null);

//   // ── Socket ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const socket = socketIo(Url, { transports: ["websocket"] });
//     socketRef.current = socket;
//     const adminToken = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
//     if (adminToken) socket.emit("joinAdmin", adminToken);

//     socket.on("support:new_ticket", (ticket) => {
//       setTickets(prev => [ticket, ...prev]);
//       Swal.fire({ toast: true, position: "top-end", icon: "info", showConfirmButton: false, timer: 4000, title: `New Ticket: #${ticket.ticketId}`, text: ticket.subject });
//     });

//     socket.on("support:ticket_updated", (updated) => {
//       setTickets(prev => prev.map(t => t._id === updated._id ? updated : t));
//       setActiveTicket(prev => prev?._id === updated._id ? updated : prev);
//     });

//     socket.on("support:ticket_deleted", ({ ticketId }) => {
//       setTickets(prev => prev.filter(t => t._id !== ticketId));
//       setActiveTicket(prev => prev?._id === ticketId ? null : prev);
//     });

//     // ── Unread count update ─────────────────────────────────────────────
//     socket.on("support:unread_update", ({ ticketId: tid, unreadByAdmin }) => {
//       if (unreadByAdmin === undefined) return;
//       setTickets(prev  => prev.map(t  => t._id === tid ? { ...t, unreadByAdmin } : t));
//       setFiltered(prev => prev.map(t  => t._id === tid ? { ...t, unreadByAdmin } : t));
//     });

//     socket.on("support:new_message", ({ ticketCode, ticketId: tid }) => {
//       // Toast only if ticket is not currently open
//       setActiveTicket(prev => {
//         if (prev?._id !== tid) {
//           Swal.fire({ toast: true, position: "top-end", icon: "message", showConfirmButton: false, timer: 2500, title: `New reply on ${ticketCode}` });
//         }
//         return prev;
//       });
//     });

//     return () => { if (socketRef.current) { socketRef.current.disconnect(); socketRef.current = null; } };
//   }, []);

//   // ── Fetch tickets ─────────────────────────────────────────────────────
//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets`);
//       const data = await res.json();
//       if (res.ok) { const list = Array.isArray(data.tickets) ? data.tickets : []; setTickets(list); setFiltered(list); }
//     } catch { console.error("Failed to fetch tickets"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchTickets(); }, [fetchTickets]);

//   // ── Mark read ─────────────────────────────────────────────────────────
//   const markRead = useCallback(async (ticketId) => {
//     try {
//       await fetch(`${Url}/api/support/tickets/${ticketId}/mark-read`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ role: "admin" }) });
//       setTickets(prev  => prev.map(t  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setFiltered(prev => prev.map(t  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setActiveTicket(prev => prev?._id === ticketId ? { ...prev, unreadByAdmin: 0 } : prev);
//     } catch {}
//   }, []);

//   // ── Fetch staff list ──────────────────────────────────────────────────
//   const fetchStaffList = async () => {
//     try {
//       const res = await fetch(`${Url}/management-staff`);
//       const data = await res.json();
//       if (res.ok) { const raw = data.staff ?? data.data ?? data ?? []; setStaffList(Array.isArray(raw) ? raw : []); }
//       else setStaffList([]);
//     } catch { setStaffList([]); }
//   };

//   // ── Filter ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let result = [...tickets];
//     if (filterStatus   !== "all") result = result.filter(t => t.status   === filterStatus);
//     if (filterPriority !== "all") result = result.filter(t => t.priority === filterPriority);
//     if (search.trim()) { const q = search.toLowerCase(); result = result.filter(t => t.ticketId?.toLowerCase().includes(q) || t.subject?.toLowerCase().includes(q) || t.clientName?.toLowerCase().includes(q) || t.projectId?.toLowerCase().includes(q)); }
//     setFiltered(result);
//   }, [filterStatus, filterPriority, search, tickets]);

//   // ── Status update ─────────────────────────────────────────────────────
//   const handleStatusChange = async (ticketId, status) => {
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ status }) });
//       const data = await res.json();
//       if (res.ok) { setActiveTicket(data.ticket); setTickets(prev => prev.map(t => t._id === data.ticket._id ? data.ticket : t)); }
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Status update failed." }); }
//   };

//   // ── Assign ────────────────────────────────────────────────────────────
//   const handleAssign = async () => {
//     if (!assignForm.staffId || !activeTicket) return;
//     setAssigning(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ staffId: assignForm.staffId, staffName: assignForm.staffName, staffRole: assignForm.staffRole, reason: assignForm.reason, adminName: "Admin" }) });
//       const data = await res.json();
//       if (res.ok) { Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false }); setActiveTicket(data.ticket); setTickets(prev => prev.map(t => t._id === data.ticket._id ? data.ticket : t)); setShowAssign(false); setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" }); }
//       else Swal.fire({ icon: "error", title: "Error", text: data.message });
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." }); }
//     finally { setAssigning(false); }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({ title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.", icon: "warning", showCancelButton: true, confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f" });
//     if (!confirm.isConfirmed) return;
//     try { await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" }); setTickets(prev => prev.filter(t => t._id !== id)); setActiveTicket(null); } catch {}
//   };

//   const formatDate    = (d) => new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
//   const totalUnread   = tickets.reduce((sum, t) => sum + (t.unreadByAdmin || 0), 0);

//   const stats = [
//     { label: "Total",       value: tickets.length,                                          color: "#1976d2", bg: "#e3f2fd" },
//     { label: "Open",        value: tickets.filter(t => t.status === "open").length,          color: "#f57c00", bg: "#fff3e0" },
//     { label: "In Progress", value: tickets.filter(t => t.status === "in-progress").length,   color: "#0288d1", bg: "#e1f5fe" },
//     { label: "Resolved",    value: tickets.filter(t => t.status === "resolved").length,      color: "#388e3c", bg: "#e8f5e9" },
//   ];

//   return (
//     <Box sx={{ p: 3 }}>
//       <style>{`@keyframes adminPulse{0%,100%{opacity:1}50%{opacity:0.6}}`}</style>

//       {/* Header */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//         <Box>
//           <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
//             <HeadsetMicIcon color="primary" /> Help & Support Tickets
//             {/* Total unread badge */}
//             {totalUnread > 0 && (
//               <Chip label={`${totalUnread} unread`} size="small" color="error" sx={{ fontWeight: 700, animation: "adminPulse 1.5s ease infinite" }} />
//             )}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">Manage and assign client support requests</Typography>
//         </Box>
//       </Box>

//       {/* Stats */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {stats.map(s => (
//           <Grid item xs={6} md={3} key={s.label}>
//             <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
//               <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
//                 <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
//                 <Typography variant="body2" color="text.secondary">{s.label}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Filters */}
//       <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
//         <TextField size="small" placeholder="Search ticket, client, project..." value={search} onChange={e => setSearch(e.target.value)} sx={{ width: 260 }} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Status</InputLabel>
//           <Select label="Status" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
//             <MenuItem value="all">All Status</MenuItem>
//             <MenuItem value="open">Open</MenuItem>
//             <MenuItem value="in-progress">In Progress</MenuItem>
//             <MenuItem value="resolved">Resolved</MenuItem>
//             <MenuItem value="closed">Closed</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Priority</InputLabel>
//           <Select label="Priority" value={filterPriority} onChange={e => setFilterPriority(e.target.value)}>
//             <MenuItem value="all">All Priority</MenuItem>
//             <MenuItem value="high">High</MenuItem>
//             <MenuItem value="medium">Medium</MenuItem>
//             <MenuItem value="low">Low</MenuItem>
//           </Select>
//         </FormControl>
//         <Tooltip title="Refresh"><IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton></Tooltip>
//       </Box>

//       {/* Table */}
//       {loading ? (
//         <Box sx={{ textAlign: "center", py: 8 }}><CircularProgress /><Typography mt={2} color="text.secondary">Loading tickets...</Typography></Box>
//       ) : filtered.length === 0 ? (
//         <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}><FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} /><Typography>No tickets found.</Typography></Box>
//       ) : (
//         <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
//           <Box sx={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ background: "#f5f5f5" }}>
//                   {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map(h => (
//                     <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555" }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((ticket, idx) => {
//                   const hasUnread = (ticket.unreadByAdmin || 0) > 0;
//                   return (
//                     <tr key={ticket._id}
//                       style={{ background: hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer", transition: "background 0.15s" }}
//                       onMouseEnter={e => e.currentTarget.style.background = "#f0f7ff"}
//                       onMouseLeave={e => e.currentTarget.style.background = hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa"}>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="caption" fontWeight={700} color="primary">#{ticket.ticketId}</Typography>
//                         {/* Per-ticket unread badge */}
//                         {hasUnread && <UnreadDot count={ticket.unreadByAdmin} />}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
//                         <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}><Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography></td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}><Typography variant="body2" noWrap>{ticket.subject === "Other" ? ticket.customSubject : ticket.subject}</Typography></td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}><Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} /></td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}><Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} /></td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         {ticket.assignedTo?.id ? (
//                           <Box display="flex" alignItems="center" gap={0.5}>
//                             <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>{ticket.assignedTo.name?.charAt(0)}</Avatar>
//                             <Typography variant="caption">{ticket.assignedTo.name}</Typography>
//                           </Box>
//                         ) : <Typography variant="caption" color="text.secondary">Unassigned</Typography>}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}><Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography></td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Box display="flex" gap={0.5}>
//                           <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => { setActiveTicket(ticket); setShowAssign(false); setShowLog(false); markRead(ticket._id); }}>
//                             View
//                           </button>
//                           <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 11 }} onClick={() => handleDelete(ticket._id)}>Del</button>
//                         </Box>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Ticket Detail Dialog ─────────────────────────────────────── */}
//       <Dialog open={!!activeTicket} onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }} maxWidth="md" fullWidth>
//         {activeTicket && (
//           <>
//             <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
//                 <Typography variant="h6" fontWeight={700}>{activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}</Typography>
//               </Box>
//               <Box display="flex" gap={1}>
//                 <Tooltip title="Escalation Log"><IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small"><HistoryIcon fontSize="small" /></IconButton></Tooltip>
//                 <Tooltip title="Assign to Staff"><IconButton onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }} size="small" color="primary"><AssignmentIndIcon fontSize="small" /></IconButton></Tooltip>
//                 <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }} size="small"><CloseIcon /></IconButton>
//               </Box>
//             </DialogTitle>
//             <Divider />

//             {/* Info Bar */}
//             <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 <Typography variant="caption"><b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}</Typography>
//               </Box>
//               <Typography variant="caption" color="text.secondary">Project: <b>{activeTicket.projectName || activeTicket.projectId}</b></Typography>
//               <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />
//               {activeTicket.assignedTo?.id && (
//                 <Box display="flex" alignItems="center" gap={0.5}>
//                   <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
//                   <Typography variant="caption" color="primary"><b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})</Typography>
//                 </Box>
//               )}
//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select value={activeTicket.status} onChange={e => handleStatusChange(activeTicket._id, e.target.value)} sx={{ fontSize: "12px", height: "28px" }}>
//                   <MenuItem value="open">Open</MenuItem>
//                   <MenuItem value="in-progress">In Progress</MenuItem>
//                   <MenuItem value="resolved">Resolved</MenuItem>
//                   <MenuItem value="closed">Closed</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <DialogContent sx={{ p: 0 }}>
//               {/* Assign Panel */}
//               {showAssign && (
//                 <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1.5}><AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />Assign Ticket to Management Staff</Typography>
//                   <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
//                     <FormControl size="small" sx={{ minWidth: 200 }}>
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select label="Select Staff" value={assignForm.staffId} onChange={e => { const s = staffList.find(x => x._id === e.target.value); setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" }); }}>
//                         <MenuItem value="">-- Select --</MenuItem>
//                         {staffList.map(s => <MenuItem key={s._id} value={s._id}>{s.name} ({s.roleName || s.slug || "staff"})</MenuItem>)}
//                       </Select>
//                     </FormControl>
//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                       <InputLabel>Role</InputLabel>
//                       <Select label="Role" value={assignForm.staffRole} onChange={e => setAssignForm({ ...assignForm, staffRole: e.target.value })}>
//                         <MenuItem value="staff">Staff</MenuItem>
//                         <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
//                       </Select>
//                     </FormControl>
//                     <TextField size="small" label="Reason (optional)" value={assignForm.reason} onChange={e => setAssignForm({ ...assignForm, reason: e.target.value })} sx={{ minWidth: 180 }} />
//                     <Button variant="contained" size="small" onClick={handleAssign} disabled={!assignForm.staffId || assigning} startIcon={<AssignmentIndIcon />}>{assigning ? "Assigning..." : "Assign"}</Button>
//                     <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
//                   </Box>
//                 </Box>
//               )}

//               {/* Escalation Log */}
//               {showLog && (
//                 <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1}><HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />Escalation Log</Typography>
//                   {!activeTicket.escalationLog?.length ? (
//                     <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
//                   ) : activeTicket.escalationLog.map((log, i) => (
//                     <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
//                       <b>{log.fromName}</b> → <b>{log.toName}</b>
//                       <Typography variant="caption" display="block" color="text.secondary">{log.reason || "N/A"} · {formatDate(log.escalatedAt)}</Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               )}

//               {/* Chat */}
//               <TicketChat ticket={activeTicket} onMarkRead={markRead}
//                 onUpdate={updated => { setActiveTicket(updated); setTickets(prev => prev.map(t => t._id === updated._id ? updated : t)); }} />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminHelpSupport;




















// "use client";

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, Paper, TextField, Select, MenuItem,
//   FormControl, InputLabel, Chip, IconButton, Dialog,
//   DialogTitle, DialogContent, CircularProgress, Grid,
//   Card, CardContent, Divider, Tooltip, InputAdornment,
//   Button, Avatar,
// } from "@mui/material";
// import SendIcon          from "@mui/icons-material/Send";
// import SearchIcon        from "@mui/icons-material/Search";
// import RefreshIcon       from "@mui/icons-material/Refresh";
// import CloseIcon         from "@mui/icons-material/Close";
// import FolderOpenIcon    from "@mui/icons-material/FolderOpen";
// import HeadsetMicIcon    from "@mui/icons-material/HeadsetMic";
// import PersonIcon        from "@mui/icons-material/Person";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import HistoryIcon       from "@mui/icons-material/History";
// import Swal              from "sweetalert2";
// import { Url }           from "src/url/url";
// import { io as socketIo } from "socket.io-client";

// const STATUS_COLOR   = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
// const PRIORITY_COLOR = { high: "error", medium: "warning", low: "success" };

// // ── Unread dot badge ──────────────────────────────────────────────────────────
// const UnreadDot = ({ count }) => {
//   if (!count || count <= 0) return null;
//   return (
//     <span style={{
//       background: "#f44336", color: "#fff", borderRadius: 50,
//       padding: "1px 7px", fontSize: 10, fontWeight: 700,
//       display: "inline-flex", alignItems: "center", justifyContent: "center",
//       marginLeft: 6, animation: "adminPulse 1.5s ease infinite",
//     }}>
//       {count > 99 ? "99+" : count}
//     </span>
//   );
// };

// // ─── Ticket Chat ──────────────────────────────────────────────────────────────
// const TicketChat = ({ ticket, onUpdate, onMarkRead }) => {
//   const [replyText, setReplyText] = useState("");
//   const [sending,   setSending]   = useState(false);
//   const chatEndRef                = useRef(null);
//   const isClosed = ticket.status === "closed";

//   useEffect(() => {
//     setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
//   }, [ticket.messages?.length]);

//   useEffect(() => {
//     if (ticket?._id && (ticket?.unreadByAdmin || 0) > 0) onMarkRead?.(ticket._id);
//   }, [ticket?._id]);

//   const handleReply = async () => {
//     if (!replyText.trim() || sending) return;
//     setSending(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
//         method: "POST", headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
//       });
//       const data = await res.json();
//       if (res.ok) { setReplyText(""); onUpdate(data.ticket); }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." });
//     } finally { setSending(false); }
//   };

//   const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

//   return (
//     <Box>
//       <Box sx={{ height: 340, overflowY: "auto", background: "#f5f7fa", px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
//         {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
//           const isAdmin  = msg.sender === "admin";
//           const isSystem = msg.senderName === "System";
//           if (isSystem) return (
//             <Box key={i} sx={{ textAlign: "center" }}>
//               <Typography variant="caption" sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}>
//                 {msg.message}
//               </Typography>
//             </Box>
//           );
//           return (
//             <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
//               {!isAdmin && (
//                 <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                   {(msg.senderName || "C").charAt(0).toUpperCase()}
//                 </Avatar>
//               )}
//               <Box sx={{ maxWidth: "74%" }}>
//                 {!isAdmin && (
//                   <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>{msg.senderName}</Typography>
//                 )}
//                 <Box sx={{
//                   px: 2, py: 1.5,
//                   borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
//                   bgcolor: isAdmin ? "#1976d2" : "#fff",
//                   color: isAdmin ? "#fff" : "inherit",
//                   border: !isAdmin ? "1px solid #e0e0e0" : "none",
//                   boxShadow: 1,
//                 }}>
//                   <Typography variant="body2">{msg.message}</Typography>
//                   <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>
//                     {fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           );
//         })}
//         <div ref={chatEndRef} />
//       </Box>

//       <Divider />

//       {isClosed ? (
//         <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
//           <Typography variant="caption" color="text.secondary">🔒 Ticket closed.</Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
//           <TextField
//             fullWidth size="small"
//             placeholder="Client ko reply karein..."
//             value={replyText}
//             onChange={(e) => setReplyText(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()}
//             sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
//           />
//           <IconButton
//             color="primary" onClick={handleReply}
//             disabled={!replyText.trim() || sending}
//             sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}
//           >
//             <SendIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// // MAIN ADMIN COMPONENT
// // ════════════════════════════════════════════════════════════════════════════
// const AdminHelpSupport = () => {
//   const [tickets,        setTickets]        = useState([]);
//   const [filtered,       setFiltered]       = useState([]);
//   const [activeTicket,   setActiveTicket]   = useState(null);
//   const [filterStatus,   setFilterStatus]   = useState("all");
//   const [filterPriority, setFilterPriority] = useState("all");
//   const [search,         setSearch]         = useState("");
//   const [loading,        setLoading]        = useState(true);
//   const [showAssign,     setShowAssign]     = useState(false);
//   const [staffList,      setStaffList]      = useState([]);
//   const [assignForm,     setAssignForm]     = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//   const [assigning,      setAssigning]      = useState(false);
//   const [showLog,        setShowLog]        = useState(false);

//   const socketRef = useRef(null);

//   // ── Fetch tickets ─────────────────────────────────────────────────────
//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets`);
//       const data = await res.json();
//       if (res.ok) {
//         const list = Array.isArray(data.tickets) ? data.tickets : [];
//         setTickets(list);
//         setFiltered(list);
//       }
//     } catch { console.error("Failed to fetch tickets"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchTickets(); }, [fetchTickets]);

//   // ── ✅ FIXED Socket — "token" key use karo ────────────────────────────
//   useEffect(() => {
//     const socket = socketIo(Url, { transports: ["websocket"] });
//     socketRef.current = socket;

//     socket.on("connect", () => {
//       // ✅ FIX: localStorage mein key "token" hai, "adminToken" nahi
//       const adminToken =
//         localStorage.getItem("adminToken") ||
//         sessionStorage.getItem("adminToken") ||
//         localStorage.getItem("token") ||        // ✅ YAHI ACTUAL KEY HAI
//         sessionStorage.getItem("token");

//       if (adminToken) {
//         socket.emit("joinAdmin", adminToken);
//       }
//     });

//     socket.on("support:new_ticket", (ticket) => {
//       setTickets((prev) => [ticket, ...prev]);
//       Swal.fire({
//         toast: true, position: "top-end", icon: "info",
//         showConfirmButton: false, timer: 4000,
//         title: `New Ticket: #${ticket.ticketId}`, text: ticket.subject,
//       });
//     });

//     socket.on("support:ticket_updated", (updated) => {
//       setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//       setActiveTicket((prev) => (prev?._id === updated._id ? updated : prev));
//     });

//     socket.on("support:ticket_deleted", ({ ticketId }) => {
//       setTickets((prev) => prev.filter((t) => t._id !== ticketId));
//       setActiveTicket((prev) => (prev?._id === ticketId ? null : prev));
//     });

//     socket.on("support:unread_update", ({ ticketId: tid, unreadByAdmin }) => {
//       if (unreadByAdmin === undefined) return;
//       setTickets((prev)  => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//       setFiltered((prev) => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//     });

//     socket.on("support:new_message", ({ ticketCode, ticketId: tid }) => {
//       setActiveTicket((prev) => {
//         if (prev?._id !== tid) {
//           Swal.fire({
//             toast: true, position: "top-end", icon: "info",
//             showConfirmButton: false, timer: 2500,
//             title: `New reply on ${ticketCode}`,
//           });
//           // Refresh list to show latest message
//           fetchTickets();
//         }
//         return prev;
//       });
//     });

//     socket.on("support:escalated", ({ ticketCode }) => {
//       Swal.fire({
//         toast: true, position: "top-end", icon: "warning",
//         showConfirmButton: false, timer: 4000,
//         title: `Ticket Escalated: #${ticketCode}`,
//       });
//       fetchTickets();
//     });

//     return () => {
//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }
//     };
//   }, [fetchTickets]);

//   // ── Mark read ─────────────────────────────────────────────────────────
//   const markRead = useCallback(async (ticketId) => {
//     try {
//       await fetch(`${Url}/api/support/tickets/${ticketId}/mark-read`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ role: "admin" }),
//       });
//       setTickets((prev)  => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setFiltered((prev) => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setActiveTicket((prev) => prev?._id === ticketId ? { ...prev, unreadByAdmin: 0 } : prev);
//     } catch {}
//   }, []);

//   // ── Fetch staff list ──────────────────────────────────────────────────
//   const fetchStaffList = async () => {
//     try {
//       const res  = await fetch(`${Url}/management-staff`);
//       const data = await res.json();
//       if (res.ok) {
//         const raw = data.staff ?? data.data ?? data ?? [];
//         setStaffList(Array.isArray(raw) ? raw : []);
//       } else setStaffList([]);
//     } catch { setStaffList([]); }
//   };

//   // ── Filter ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let result = [...tickets];
//     if (filterStatus   !== "all") result = result.filter((t) => t.status   === filterStatus);
//     if (filterPriority !== "all") result = result.filter((t) => t.priority === filterPriority);
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       result = result.filter((t) =>
//         t.ticketId?.toLowerCase().includes(q) ||
//         t.subject?.toLowerCase().includes(q) ||
//         t.clientName?.toLowerCase().includes(q) ||
//         t.projectId?.toLowerCase().includes(q)
//       );
//     }
//     setFiltered(result);
//   }, [filterStatus, filterPriority, search, tickets]);

//   // ── Status update ─────────────────────────────────────────────────────
//   const handleStatusChange = async (ticketId, status) => {
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ status }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//       }
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Status update failed." }); }
//   };

//   // ── Assign ────────────────────────────────────────────────────────────
//   const handleAssign = async () => {
//     if (!assignForm.staffId || !activeTicket) return;
//     setAssigning(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           staffId:   assignForm.staffId,
//           staffName: assignForm.staffName,
//           staffRole: assignForm.staffRole,
//           reason:    assignForm.reason,
//           adminName: "Admin",
//         }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false });
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//         setShowAssign(false);
//         setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//       } else Swal.fire({ icon: "error", title: "Error", text: data.message });
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." }); }
//     finally { setAssigning(false); }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.",
//       icon: "warning", showCancelButton: true,
//       confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f",
//     });
//     if (!confirm.isConfirmed) return;
//     try {
//       await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" });
//       setTickets((prev) => prev.filter((t) => t._id !== id));
//       setActiveTicket(null);
//     } catch {}
//   };

//   const formatDate  = (d) => new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
//   const totalUnread = tickets.reduce((sum, t) => sum + (t.unreadByAdmin || 0), 0);

//   const stats = [
//     { label: "Total",       value: tickets.length,                                          color: "#1976d2", bg: "#e3f2fd" },
//     { label: "Open",        value: tickets.filter((t) => t.status === "open").length,        color: "#f57c00", bg: "#fff3e0" },
//     { label: "In Progress", value: tickets.filter((t) => t.status === "in-progress").length, color: "#0288d1", bg: "#e1f5fe" },
//     { label: "Resolved",    value: tickets.filter((t) => t.status === "resolved").length,    color: "#388e3c", bg: "#e8f5e9" },
//   ];

//   return (
//     <Box sx={{ p: 3 }}>
//       <style>{`@keyframes adminPulse{0%,100%{opacity:1}50%{opacity:0.6}}`}</style>

//       {/* Header */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//         <Box>
//           <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
//             <HeadsetMicIcon color="primary" /> Help & Support Tickets
//             {totalUnread > 0 && (
//               <Chip label={`${totalUnread} unread`} size="small" color="error" sx={{ fontWeight: 700, animation: "adminPulse 1.5s ease infinite" }} />
//             )}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">Manage and assign client support requests</Typography>
//         </Box>
//       </Box>

//       {/* Stats */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {stats.map((s) => (
//           <Grid item xs={6} md={3} key={s.label}>
//             <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
//               <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
//                 <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
//                 <Typography variant="body2" color="text.secondary">{s.label}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Filters */}
//       <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
//         <TextField
//           size="small" placeholder="Search ticket, client, project..."
//           value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: 260 }}
//           InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
//         />
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Status</InputLabel>
//           <Select label="Status" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//             <MenuItem value="all">All Status</MenuItem>
//             <MenuItem value="open">Open</MenuItem>
//             <MenuItem value="in-progress">In Progress</MenuItem>
//             <MenuItem value="resolved">Resolved</MenuItem>
//             <MenuItem value="closed">Closed</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Priority</InputLabel>
//           <Select label="Priority" value={filterPriority} onChange={(e) => setFilterPriority(e.target.value)}>
//             <MenuItem value="all">All Priority</MenuItem>
//             <MenuItem value="high">High</MenuItem>
//             <MenuItem value="medium">Medium</MenuItem>
//             <MenuItem value="low">Low</MenuItem>
//           </Select>
//         </FormControl>
//         <Tooltip title="Refresh">
//           <IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton>
//         </Tooltip>
//       </Box>

//       {/* Table */}
//       {loading ? (
//         <Box sx={{ textAlign: "center", py: 8 }}>
//           <CircularProgress />
//           <Typography mt={2} color="text.secondary">Loading tickets...</Typography>
//         </Box>
//       ) : filtered.length === 0 ? (
//         <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
//           <FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} />
//           <Typography>No tickets found.</Typography>
//         </Box>
//       ) : (
//         <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
//           <Box sx={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ background: "#f5f5f5" }}>
//                   {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map((h) => (
//                     <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555" }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((ticket, idx) => {
//                   const hasUnread = (ticket.unreadByAdmin || 0) > 0;
//                   return (
//                     <tr key={ticket._id}
//                       style={{ background: hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer", transition: "background 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
//                       onMouseLeave={(e) => (e.currentTarget.style.background = hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa")}
//                     >
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="caption" fontWeight={700} color="primary">#{ticket.ticketId}</Typography>
//                         {hasUnread && <UnreadDot count={ticket.unreadByAdmin} />}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
//                         <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}>
//                         <Typography variant="body2" noWrap>{ticket.subject === "Other" ? ticket.customSubject : ticket.subject}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         {ticket.assignedTo?.id ? (
//                           <Box display="flex" alignItems="center" gap={0.5}>
//                             <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                               {ticket.assignedTo.name?.charAt(0)}
//                             </Avatar>
//                             <Typography variant="caption">{ticket.assignedTo.name}</Typography>
//                           </Box>
//                         ) : (
//                           <Typography variant="caption" color="text.secondary">Unassigned</Typography>
//                         )}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
//                         <Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Box display="flex" gap={0.5}>
//                           <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => { setActiveTicket(ticket); setShowAssign(false); setShowLog(false); markRead(ticket._id); }}>
//                             View
//                           </button>
//                           <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => handleDelete(ticket._id)}>
//                             Del
//                           </button>
//                         </Box>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Ticket Detail Dialog ─────────────────────────────────────── */}
//       <Dialog
//         open={!!activeTicket}
//         onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }}
//         maxWidth="md" fullWidth
//       >
//         {activeTicket && (
//           <>
//             <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
//                 <Typography variant="h6" fontWeight={700}>
//                   {activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}
//                 </Typography>
//               </Box>
//               <Box display="flex" gap={1}>
//                 <Tooltip title="Escalation Log">
//                   <IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small">
//                     <HistoryIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Assign to Staff">
//                   <IconButton onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }} size="small" color="primary">
//                     <AssignmentIndIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); }} size="small">
//                   <CloseIcon />
//                 </IconButton>
//               </Box>
//             </DialogTitle>

//             <Divider />

//             {/* Info Bar */}
//             <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 <Typography variant="caption">
//                   <b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}
//                 </Typography>
//               </Box>
//               <Typography variant="caption" color="text.secondary">
//                 Project: <b>{activeTicket.projectName || activeTicket.projectId}</b>
//               </Typography>
//               <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />
//               {activeTicket.assignedTo?.id && (
//                 <Box display="flex" alignItems="center" gap={0.5}>
//                   <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
//                   <Typography variant="caption" color="primary">
//                     <b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})
//                   </Typography>
//                 </Box>
//               )}
//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select
//                   value={activeTicket.status}
//                   onChange={(e) => handleStatusChange(activeTicket._id, e.target.value)}
//                   sx={{ fontSize: "12px", height: "28px" }}
//                 >
//                   <MenuItem value="open">Open</MenuItem>
//                   <MenuItem value="in-progress">In Progress</MenuItem>
//                   <MenuItem value="resolved">Resolved</MenuItem>
//                   <MenuItem value="closed">Closed</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <DialogContent sx={{ p: 0 }}>
//               {/* Assign Panel */}
//               {showAssign && (
//                 <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
//                     <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Assign Ticket to Management Staff
//                   </Typography>
//                   <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
//                     <FormControl size="small" sx={{ minWidth: 200 }}>
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         label="Select Staff"
//                         value={assignForm.staffId}
//                         onChange={(e) => {
//                           const s = staffList.find((x) => x._id === e.target.value);
//                           setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" });
//                         }}
//                       >
//                         <MenuItem value="">-- Select --</MenuItem>
//                         {staffList.map((s) => (
//                           <MenuItem key={s._id} value={s._id}>{s.name} ({s.roleName || s.slug || "staff"})</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                       <InputLabel>Role</InputLabel>
//                       <Select label="Role" value={assignForm.staffRole} onChange={(e) => setAssignForm({ ...assignForm, staffRole: e.target.value })}>
//                         <MenuItem value="staff">Staff</MenuItem>
//                         <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
//                       </Select>
//                     </FormControl>
//                     <TextField
//                       size="small" label="Reason (optional)"
//                       value={assignForm.reason}
//                       onChange={(e) => setAssignForm({ ...assignForm, reason: e.target.value })}
//                       sx={{ minWidth: 180 }}
//                     />
//                     <Button variant="contained" size="small" onClick={handleAssign}
//                       disabled={!assignForm.staffId || assigning} startIcon={<AssignmentIndIcon />}>
//                       {assigning ? "Assigning..." : "Assign"}
//                     </Button>
//                     <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
//                   </Box>
//                 </Box>
//               )}

//               {/* Escalation Log */}
//               {showLog && (
//                 <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1}>
//                     <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Escalation Log
//                   </Typography>
//                   {!activeTicket.escalationLog?.length ? (
//                     <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
//                   ) : (
//                     activeTicket.escalationLog.map((log, i) => (
//                       <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
//                         <b>{log.fromName}</b> → <b>{log.toName}</b>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                           {log.reason || "N/A"} · {formatDate(log.escalatedAt)}
//                         </Typography>
//                       </Box>
//                     ))
//                   )}
//                 </Box>
//               )}

//               {/* Chat */}
//               <TicketChat
//                 ticket={activeTicket}
//                 onMarkRead={markRead}
//                 onUpdate={(updated) => {
//                   setActiveTicket(updated);
//                   setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//                 }}
//               />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminHelpSupport;











// "use client";

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, Paper, TextField, Select, MenuItem,
//   FormControl, InputLabel, Chip, IconButton, Dialog,
//   DialogTitle, DialogContent, CircularProgress, Grid,
//   Card, CardContent, Divider, Tooltip, InputAdornment,
//   Button, Avatar,
// } from "@mui/material";
// import SendIcon          from "@mui/icons-material/Send";
// import SearchIcon        from "@mui/icons-material/Search";
// import RefreshIcon       from "@mui/icons-material/Refresh";
// import CloseIcon         from "@mui/icons-material/Close";
// import FolderOpenIcon    from "@mui/icons-material/FolderOpen";
// import HeadsetMicIcon    from "@mui/icons-material/HeadsetMic";
// import PersonIcon        from "@mui/icons-material/Person";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import HistoryIcon       from "@mui/icons-material/History";
// import WarningAmberIcon  from "@mui/icons-material/WarningAmber";
// import Swal              from "sweetalert2";
// import { Url }           from "src/url/url";
// import { io as socketIo } from "socket.io-client";

// const STATUS_COLOR   = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
// const PRIORITY_COLOR = { high: "error", medium: "warning", low: "success" };

// // ── Unread dot badge ──────────────────────────────────────────────────────────
// const UnreadDot = ({ count }) => {
//   if (!count || count <= 0) return null;
//   return (
//     <span style={{
//       background: "#f44336", color: "#fff", borderRadius: 50,
//       padding: "1px 7px", fontSize: 10, fontWeight: 700,
//       display: "inline-flex", alignItems: "center", justifyContent: "center",
//       marginLeft: 6, animation: "adminPulse 1.5s ease infinite",
//     }}>
//       {count > 99 ? "99+" : count}
//     </span>
//   );
// };

// // ─── Ticket Chat ──────────────────────────────────────────────────────────────
// const TicketChat = ({ ticket, onUpdate, onMarkRead }) => {
//   const [replyText, setReplyText] = useState("");
//   const [sending,   setSending]   = useState(false);
//   const chatEndRef                = useRef(null);
//   const isClosed = ticket.status === "closed";

//   useEffect(() => {
//     setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
//   }, [ticket.messages?.length]);

//   useEffect(() => {
//     if (ticket?._id && (ticket?.unreadByAdmin || 0) > 0) onMarkRead?.(ticket._id);
//   }, [ticket?._id]);

//   const handleReply = async () => {
//     if (!replyText.trim() || sending) return;
//     setSending(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
//         method: "POST", headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
//       });
//       const data = await res.json();
//       if (res.ok) { setReplyText(""); onUpdate(data.ticket); }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." });
//     } finally { setSending(false); }
//   };

//   const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

//   return (
//     <Box>
//       <Box sx={{ height: 340, overflowY: "auto", background: "#f5f7fa", px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
//         {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
//           const isAdmin  = msg.sender === "admin";
//           const isSystem = msg.senderName === "System";
//           if (isSystem) return (
//             <Box key={i} sx={{ textAlign: "center" }}>
//               <Typography variant="caption" sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}>
//                 {msg.message}
//               </Typography>
//             </Box>
//           );
//           return (
//             <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
//               {!isAdmin && (
//                 <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                   {(msg.senderName || "C").charAt(0).toUpperCase()}
//                 </Avatar>
//               )}
//               <Box sx={{ maxWidth: "74%" }}>
//                 {!isAdmin && (
//                   <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>{msg.senderName}</Typography>
//                 )}
//                 <Box sx={{
//                   px: 2, py: 1.5,
//                   borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
//                   bgcolor: isAdmin ? "#1976d2" : "#fff",
//                   color: isAdmin ? "#fff" : "inherit",
//                   border: !isAdmin ? "1px solid #e0e0e0" : "none",
//                   boxShadow: 1,
//                 }}>
//                   <Typography variant="body2">{msg.message}</Typography>
//                   <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>
//                     {fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           );
//         })}
//         <div ref={chatEndRef} />
//       </Box>

//       <Divider />

//       {isClosed ? (
//         <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
//           <Typography variant="caption" color="text.secondary">🔒 Ticket closed.</Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
//           <TextField
//             fullWidth size="small"
//             placeholder="Client ko reply karein..."
//             value={replyText}
//             onChange={(e) => setReplyText(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()}
//             sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
//           />
//           <IconButton
//             color="primary" onClick={handleReply}
//             disabled={!replyText.trim() || sending}
//             sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}
//           >
//             <SendIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ─── Related Tickets Banner ───────────────────────────────────────────────────
// const RelatedTicketsBanner = ({ tickets, onSelect }) => {
//   if (!tickets || tickets.length === 0) return null;

//   return (
//     <Box sx={{
//       px: 2.5, py: 1.5,
//       background: "linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)",
//       borderBottom: "1px solid #ffe082",
//     }}>
//       <Box display="flex" alignItems="center" gap={0.8} mb={1}>
//         <WarningAmberIcon sx={{ fontSize: 15, color: "#e65100" }} />
//         <Typography variant="caption" fontWeight={700} color="#e65100">
//           Is project pe {tickets.length} aur active ticket{tickets.length > 1 ? "s" : ""} hain (same subject)
//         </Typography>
//       </Box>
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 0.7 }}>
//         {tickets.map((t) => (
//           <Box
//             key={t._id}
//             onClick={() => onSelect(t)}
//             sx={{
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               background: "#fff", border: "1px solid #ffe082", borderRadius: 2,
//               px: 1.5, py: 0.8, cursor: "pointer", transition: "all 0.15s",
//               "&:hover": { background: "#fff3e0", borderColor: "#ffca28", transform: "translateX(2px)" },
//             }}
//           >
//             <Box display="flex" alignItems="center" gap={1}>
//               <Typography variant="caption" fontWeight={700} color="primary">
//                 #{t.ticketId}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {t.clientName}
//               </Typography>
//               {t.messages?.length > 0 && (
//                 <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
//                   · {t.messages.length} msg(s)
//                 </Typography>
//               )}
//             </Box>
//             <Box display="flex" gap={0.5} alignItems="center">
//               <Chip
//                 label={t.status} size="small"
//                 color={STATUS_COLOR[t.status] || "default"}
//                 sx={{ fontSize: "10px", height: 20 }}
//               />
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10, whiteSpace: "nowrap" }}>
//                 {new Date(t.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
//               </Typography>
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// // MAIN ADMIN COMPONENT
// // ════════════════════════════════════════════════════════════════════════════
// const AdminHelpSupport = () => {
//   const [tickets,        setTickets]        = useState([]);
//   const [filtered,       setFiltered]       = useState([]);
//   const [activeTicket,   setActiveTicket]   = useState(null);
//   const [filterStatus,   setFilterStatus]   = useState("all");
//   const [filterPriority, setFilterPriority] = useState("all");
//   const [search,         setSearch]         = useState("");
//   const [loading,        setLoading]        = useState(true);
//   const [showAssign,     setShowAssign]     = useState(false);
//   const [staffList,      setStaffList]      = useState([]);
//   const [assignForm,     setAssignForm]     = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//   const [assigning,      setAssigning]      = useState(false);
//   const [showLog,        setShowLog]        = useState(false);

//   // ── Related tickets state ─────────────────────────────────────────────
//   const [relatedTickets, setRelatedTickets] = useState([]);

//   const socketRef = useRef(null);

//   // ── Fetch tickets ─────────────────────────────────────────────────────
//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets`);
//       const data = await res.json();
//       if (res.ok) {
//         const list = Array.isArray(data.tickets) ? data.tickets : [];
//         setTickets(list);
//         setFiltered(list);
//       }
//     } catch { console.error("Failed to fetch tickets"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchTickets(); }, [fetchTickets]);

//   // ── Fetch related tickets ─────────────────────────────────────────────
//   const fetchRelated = useCallback(async (ticket) => {
//     if (!ticket?.projectId || !ticket?.subject) {
//       setRelatedTickets([]);
//       return;
//     }
//     try {
//       const res = await fetch(
//         `${Url}/api/support/tickets/related/${ticket.projectId}/${encodeURIComponent(ticket.subject)}?excludeId=${ticket._id}`
//       );
//       const data = await res.json();
//       setRelatedTickets(res.ok ? (data.tickets || []) : []);
//     } catch {
//       setRelatedTickets([]);
//     }
//   }, []);

//   // activeTicket change hone par related fetch karo
//   useEffect(() => {
//     if (activeTicket) fetchRelated(activeTicket);
//     else setRelatedTickets([]);
//   }, [activeTicket, fetchRelated]);

//   // ── Socket ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const socket = socketIo(Url, { transports: ["websocket"] });
//     socketRef.current = socket;

//     socket.on("connect", () => {
//       const adminToken =
//         localStorage.getItem("adminToken") ||
//         sessionStorage.getItem("adminToken") ||
//         localStorage.getItem("token") ||
//         sessionStorage.getItem("token");

//       if (adminToken) {
//         socket.emit("joinAdmin", adminToken);
//       }
//     });

//     socket.on("support:new_ticket", (ticket) => {
//       setTickets((prev) => [ticket, ...prev]);
//       Swal.fire({
//         toast: true, position: "top-end", icon: "info",
//         showConfirmButton: false, timer: 4000,
//         title: `New Ticket: #${ticket.ticketId}`, text: ticket.subject,
//       });
//     });

//     socket.on("support:ticket_updated", (updated) => {
//       setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//       setActiveTicket((prev) => (prev?._id === updated._id ? updated : prev));
//     });

//     socket.on("support:ticket_deleted", ({ ticketId }) => {
//       setTickets((prev) => prev.filter((t) => t._id !== ticketId));
//       setActiveTicket((prev) => (prev?._id === ticketId ? null : prev));
//     });

//     socket.on("support:unread_update", ({ ticketId: tid, unreadByAdmin }) => {
//       if (unreadByAdmin === undefined) return;
//       setTickets((prev)  => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//       setFiltered((prev) => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//     });

//     socket.on("support:new_message", ({ ticketCode, ticketId: tid }) => {
//       setActiveTicket((prev) => {
//         if (prev?._id !== tid) {
//           Swal.fire({
//             toast: true, position: "top-end", icon: "info",
//             showConfirmButton: false, timer: 2500,
//             title: `New reply on ${ticketCode}`,
//           });
//           fetchTickets();
//         }
//         return prev;
//       });
//     });

//     socket.on("support:escalated", ({ ticketCode }) => {
//       Swal.fire({
//         toast: true, position: "top-end", icon: "warning",
//         showConfirmButton: false, timer: 4000,
//         title: `Ticket Escalated: #${ticketCode}`,
//       });
//       fetchTickets();
//     });

//     return () => {
//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }
//     };
//   }, [fetchTickets]);

//   // ── Mark read ─────────────────────────────────────────────────────────
//   const markRead = useCallback(async (ticketId) => {
//     try {
//       await fetch(`${Url}/api/support/tickets/${ticketId}/mark-read`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ role: "admin" }),
//       });
//       setTickets((prev)  => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setFiltered((prev) => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setActiveTicket((prev) => prev?._id === ticketId ? { ...prev, unreadByAdmin: 0 } : prev);
//     } catch {}
//   }, []);

//   // ── Fetch staff list ──────────────────────────────────────────────────
//   const fetchStaffList = async () => {
//     try {
//       const res  = await fetch(`${Url}/management-staff`);
//       const data = await res.json();
//       if (res.ok) {
//         const raw = data.staff ?? data.data ?? data ?? [];
//         setStaffList(Array.isArray(raw) ? raw : []);
//       } else setStaffList([]);
//     } catch { setStaffList([]); }
//   };

//   // ── Filter ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let result = [...tickets];
//     if (filterStatus   !== "all") result = result.filter((t) => t.status   === filterStatus);
//     if (filterPriority !== "all") result = result.filter((t) => t.priority === filterPriority);
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       result = result.filter((t) =>
//         t.ticketId?.toLowerCase().includes(q) ||
//         t.subject?.toLowerCase().includes(q) ||
//         t.clientName?.toLowerCase().includes(q) ||
//         t.projectId?.toLowerCase().includes(q)
//       );
//     }
//     setFiltered(result);
//   }, [filterStatus, filterPriority, search, tickets]);

//   // ── Status update ─────────────────────────────────────────────────────
//   const handleStatusChange = async (ticketId, status) => {
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ status }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//       }
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Status update failed." }); }
//   };

//   // ── Assign ────────────────────────────────────────────────────────────
//   const handleAssign = async () => {
//     if (!assignForm.staffId || !activeTicket) return;
//     setAssigning(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           staffId:   assignForm.staffId,
//           staffName: assignForm.staffName,
//           staffRole: assignForm.staffRole,
//           reason:    assignForm.reason,
//           adminName: "Admin",
//         }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false });
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//         setShowAssign(false);
//         setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//       } else Swal.fire({ icon: "error", title: "Error", text: data.message });
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." }); }
//     finally { setAssigning(false); }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.",
//       icon: "warning", showCancelButton: true,
//       confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f",
//     });
//     if (!confirm.isConfirmed) return;
//     try {
//       await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" });
//       setTickets((prev) => prev.filter((t) => t._id !== id));
//       setActiveTicket(null);
//     } catch {}
//   };

//   // ── Open ticket (from table or related banner) ────────────────────────
//   const openTicket = (ticket) => {
//     setActiveTicket(ticket);
//     setShowAssign(false);
//     setShowLog(false);
//     markRead(ticket._id);
//   };

//   const formatDate  = (d) => new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
//   const totalUnread = tickets.reduce((sum, t) => sum + (t.unreadByAdmin || 0), 0);

//   const stats = [
//     { label: "Total",       value: tickets.length,                                          color: "#1976d2", bg: "#e3f2fd" },
//     { label: "Open",        value: tickets.filter((t) => t.status === "open").length,        color: "#f57c00", bg: "#fff3e0" },
//     { label: "In Progress", value: tickets.filter((t) => t.status === "in-progress").length, color: "#0288d1", bg: "#e1f5fe" },
//     { label: "Resolved",    value: tickets.filter((t) => t.status === "resolved").length,    color: "#388e3c", bg: "#e8f5e9" },
//   ];

//   return (
//     <Box sx={{ p: 3 }}>
//       <style>{`@keyframes adminPulse{0%,100%{opacity:1}50%{opacity:0.6}}`}</style>

//       {/* Header */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//         <Box>
//           <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
//             <HeadsetMicIcon color="primary" /> Help & Support Tickets
//             {totalUnread > 0 && (
//               <Chip label={`${totalUnread} unread`} size="small" color="error" sx={{ fontWeight: 700, animation: "adminPulse 1.5s ease infinite" }} />
//             )}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">Manage and assign client support requests</Typography>
//         </Box>
//       </Box>

//       {/* Stats */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {stats.map((s) => (
//           <Grid item xs={6} md={3} key={s.label}>
//             <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
//               <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
//                 <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
//                 <Typography variant="body2" color="text.secondary">{s.label}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Filters */}
//       <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
//         <TextField
//           size="small" placeholder="Search ticket, client, project..."
//           value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: 260 }}
//           InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
//         />
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Status</InputLabel>
//           <Select label="Status" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//             <MenuItem value="all">All Status</MenuItem>
//             <MenuItem value="open">Open</MenuItem>
//             <MenuItem value="in-progress">In Progress</MenuItem>
//             <MenuItem value="resolved">Resolved</MenuItem>
//             <MenuItem value="closed">Closed</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Priority</InputLabel>
//           <Select label="Priority" value={filterPriority} onChange={(e) => setFilterPriority(e.target.value)}>
//             <MenuItem value="all">All Priority</MenuItem>
//             <MenuItem value="high">High</MenuItem>
//             <MenuItem value="medium">Medium</MenuItem>
//             <MenuItem value="low">Low</MenuItem>
//           </Select>
//         </FormControl>
//         <Tooltip title="Refresh">
//           <IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton>
//         </Tooltip>
//       </Box>

//       {/* Table */}
//       {loading ? (
//         <Box sx={{ textAlign: "center", py: 8 }}>
//           <CircularProgress />
//           <Typography mt={2} color="text.secondary">Loading tickets...</Typography>
//         </Box>
//       ) : filtered.length === 0 ? (
//         <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
//           <FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} />
//           <Typography>No tickets found.</Typography>
//         </Box>
//       ) : (
//         <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
//           <Box sx={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ background: "#f5f5f5" }}>
//                   {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map((h) => (
//                     <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555" }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((ticket, idx) => {
//                   const hasUnread = (ticket.unreadByAdmin || 0) > 0;
//                   return (
//                     <tr key={ticket._id}
//                       style={{ background: hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer", transition: "background 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
//                       onMouseLeave={(e) => (e.currentTarget.style.background = hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa")}
//                     >
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="caption" fontWeight={700} color="primary">#{ticket.ticketId}</Typography>
//                         {hasUnread && <UnreadDot count={ticket.unreadByAdmin} />}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
//                         <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}>
//                         <Typography variant="body2" noWrap>{ticket.subject === "Other" ? ticket.customSubject : ticket.subject}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         {ticket.assignedTo?.id ? (
//                           <Box display="flex" alignItems="center" gap={0.5}>
//                             <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                               {ticket.assignedTo.name?.charAt(0)}
//                             </Avatar>
//                             <Typography variant="caption">{ticket.assignedTo.name}</Typography>
//                           </Box>
//                         ) : (
//                           <Typography variant="caption" color="text.secondary">Unassigned</Typography>
//                         )}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
//                         <Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Box display="flex" gap={0.5}>
//                           <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => openTicket(ticket)}>
//                             View
//                           </button>
//                           <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => handleDelete(ticket._id)}>
//                             Del
//                           </button>
//                         </Box>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Ticket Detail Dialog ─────────────────────────────────────── */}
//       <Dialog
//         open={!!activeTicket}
//         onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }}
//         maxWidth="md" fullWidth
//       >
//         {activeTicket && (
//           <>
//             <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
//                 <Typography variant="h6" fontWeight={700}>
//                   {activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}
//                 </Typography>
//               </Box>
//               <Box display="flex" gap={1}>
//                 <Tooltip title="Escalation Log">
//                   <IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small">
//                     <HistoryIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Assign to Staff">
//                   <IconButton onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }} size="small" color="primary">
//                     <AssignmentIndIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }} size="small">
//                   <CloseIcon />
//                 </IconButton>
//               </Box>
//             </DialogTitle>

//             <Divider />

//             {/* Info Bar */}
//             <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 <Typography variant="caption">
//                   <b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}
//                 </Typography>
//               </Box>
//               <Typography variant="caption" color="text.secondary">
//                 Project: <b>{activeTicket.projectName || activeTicket.projectId}</b>
//               </Typography>
//               <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />
//               {activeTicket.assignedTo?.id && (
//                 <Box display="flex" alignItems="center" gap={0.5}>
//                   <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
//                   <Typography variant="caption" color="primary">
//                     <b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})
//                   </Typography>
//                 </Box>
//               )}
//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select
//                   value={activeTicket.status}
//                   onChange={(e) => handleStatusChange(activeTicket._id, e.target.value)}
//                   sx={{ fontSize: "12px", height: "28px" }}
//                 >
//                   <MenuItem value="open">Open</MenuItem>
//                   <MenuItem value="in-progress">In Progress</MenuItem>
//                   <MenuItem value="resolved">Resolved</MenuItem>
//                   <MenuItem value="closed">Closed</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <DialogContent sx={{ p: 0 }}>
//               {/* ── Related Tickets Banner ──────────────────────────── */}
//               <RelatedTicketsBanner
//                 tickets={relatedTickets}
//                 onSelect={(t) => openTicket(t)}
//               />

//               {/* Assign Panel */}
//               {showAssign && (
//                 <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
//                     <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Assign Ticket to Management Staff
//                   </Typography>
//                   <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
//                     <FormControl size="small" sx={{ minWidth: 200 }}>
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         label="Select Staff"
//                         value={assignForm.staffId}
//                         onChange={(e) => {
//                           const s = staffList.find((x) => x._id === e.target.value);
//                           setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" });
//                         }}
//                       >
//                         <MenuItem value="">-- Select --</MenuItem>
//                         {staffList.map((s) => (
//                           <MenuItem key={s._id} value={s._id}>{s.name} ({s.roleName || s.slug || "staff"})</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                       <InputLabel>Role</InputLabel>
//                       <Select label="Role" value={assignForm.staffRole} onChange={(e) => setAssignForm({ ...assignForm, staffRole: e.target.value })}>
//                         <MenuItem value="staff">Staff</MenuItem>
//                         <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
//                       </Select>
//                     </FormControl>
//                     <TextField
//                       size="small" label="Reason (optional)"
//                       value={assignForm.reason}
//                       onChange={(e) => setAssignForm({ ...assignForm, reason: e.target.value })}
//                       sx={{ minWidth: 180 }}
//                     />
//                     <Button variant="contained" size="small" onClick={handleAssign}
//                       disabled={!assignForm.staffId || assigning} startIcon={<AssignmentIndIcon />}>
//                       {assigning ? "Assigning..." : "Assign"}
//                     </Button>
//                     <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
//                   </Box>
//                 </Box>
//               )}

//               {/* Escalation Log */}
//               {showLog && (
//                 <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1}>
//                     <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Escalation Log
//                   </Typography>
//                   {!activeTicket.escalationLog?.length ? (
//                     <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
//                   ) : (
//                     activeTicket.escalationLog.map((log, i) => (
//                       <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
//                         <b>{log.fromName}</b> → <b>{log.toName}</b>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                           {log.reason || "N/A"} · {formatDate(log.escalatedAt)}
//                         </Typography>
//                       </Box>
//                     ))
//                   )}
//                 </Box>
//               )}

//               {/* Chat */}
//               <TicketChat
//                 ticket={activeTicket}
//                 onMarkRead={markRead}
//                 onUpdate={(updated) => {
//                   setActiveTicket(updated);
//                   setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//                 }}
//               />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminHelpSupport;


















// "use client";

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   Box, Typography, Paper, TextField, Select, MenuItem,
//   FormControl, InputLabel, Chip, IconButton, Dialog,
//   DialogTitle, DialogContent, CircularProgress, Grid,
//   Card, CardContent, Divider, Tooltip, InputAdornment,
//   Button, Avatar,
// } from "@mui/material";
// import SendIcon          from "@mui/icons-material/Send";
// import SearchIcon        from "@mui/icons-material/Search";
// import RefreshIcon       from "@mui/icons-material/Refresh";
// import CloseIcon         from "@mui/icons-material/Close";
// import FolderOpenIcon    from "@mui/icons-material/FolderOpen";
// import HeadsetMicIcon    from "@mui/icons-material/HeadsetMic";
// import PersonIcon        from "@mui/icons-material/Person";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import HistoryIcon       from "@mui/icons-material/History";
// import WarningAmberIcon  from "@mui/icons-material/WarningAmber";
// import LaunchIcon        from "@mui/icons-material/Launch";
// import Swal              from "sweetalert2";
// import { Url }           from "src/url/url";
// import { io as socketIo } from "socket.io-client";
// import { useNavigate }   from "react-router-dom";

// const STATUS_COLOR   = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
// const PRIORITY_COLOR = { high: "error", medium: "warning", low: "success" };

// // ── Unread dot badge ──────────────────────────────────────────────────────────
// const UnreadDot = ({ count }) => {
//   if (!count || count <= 0) return null;
//   return (
//     <span style={{
//       background: "#f44336", color: "#fff", borderRadius: 50,
//       padding: "1px 7px", fontSize: 10, fontWeight: 700,
//       display: "inline-flex", alignItems: "center", justifyContent: "center",
//       marginLeft: 6, animation: "adminPulse 1.5s ease infinite",
//     }}>
//       {count > 99 ? "99+" : count}
//     </span>
//   );
// };

// // ─── Ticket Chat ──────────────────────────────────────────────────────────────
// const TicketChat = ({ ticket, onUpdate, onMarkRead }) => {
//   const [replyText, setReplyText] = useState("");
//   const [sending,   setSending]   = useState(false);
//   const chatEndRef                = useRef(null);
//   const isClosed = ticket.status === "closed";

//   useEffect(() => {
//     setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
//   }, [ticket.messages?.length]);

//   useEffect(() => {
//     if (ticket?._id && (ticket?.unreadByAdmin || 0) > 0) onMarkRead?.(ticket._id);
//   }, [ticket?._id]);

//   const handleReply = async () => {
//     if (!replyText.trim() || sending) return;
//     setSending(true);
//     try {
//       const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
//         method: "POST", headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
//       });
//       const data = await res.json();
//       if (res.ok) { setReplyText(""); onUpdate(data.ticket); }
//     } catch {
//       Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." });
//     } finally { setSending(false); }
//   };

//   const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
//   const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

//   return (
//     <Box>
//       <Box sx={{ height: 340, overflowY: "auto", background: "#f5f7fa", px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
//         {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
//           const isAdmin  = msg.sender === "admin";
//           const isSystem = msg.senderName === "System";
//           if (isSystem) return (
//             <Box key={i} sx={{ textAlign: "center" }}>
//               <Typography variant="caption" sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}>
//                 {msg.message}
//               </Typography>
//             </Box>
//           );
//           return (
//             <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
//               {!isAdmin && (
//                 <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                   {(msg.senderName || "C").charAt(0).toUpperCase()}
//                 </Avatar>
//               )}
//               <Box sx={{ maxWidth: "74%" }}>
//                 {!isAdmin && (
//                   <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>{msg.senderName}</Typography>
//                 )}
//                 <Box sx={{
//                   px: 2, py: 1.5,
//                   borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
//                   bgcolor: isAdmin ? "#1976d2" : "#fff",
//                   color: isAdmin ? "#fff" : "inherit",
//                   border: !isAdmin ? "1px solid #e0e0e0" : "none",
//                   boxShadow: 1,
//                 }}>
//                   <Typography variant="body2">{msg.message}</Typography>
//                   <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>
//                     {fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           );
//         })}
//         <div ref={chatEndRef} />
//       </Box>

//       <Divider />

//       {isClosed ? (
//         <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
//           <Typography variant="caption" color="text.secondary">🔒 Ticket closed.</Typography>
//         </Box>
//       ) : (
//         <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
//           <TextField
//             fullWidth size="small"
//             placeholder="Client ko reply karein..."
//             value={replyText}
//             onChange={(e) => setReplyText(e.target.value)}
//             onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()}
//             sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
//           />
//           <IconButton
//             color="primary" onClick={handleReply}
//             disabled={!replyText.trim() || sending}
//             sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}
//           >
//             <SendIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ─── Related Tickets Banner ───────────────────────────────────────────────────
// const RelatedTicketsBanner = ({ tickets, onSelect }) => {
//   if (!tickets || tickets.length === 0) return null;

//   return (
//     <Box sx={{
//       px: 2.5, py: 1.5,
//       background: "linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)",
//       borderBottom: "1px solid #ffe082",
//     }}>
//       <Box display="flex" alignItems="center" gap={0.8} mb={1}>
//         <WarningAmberIcon sx={{ fontSize: 15, color: "#e65100" }} />
//         <Typography variant="caption" fontWeight={700} color="#e65100">
//           Is project pe {tickets.length} aur active ticket{tickets.length > 1 ? "s" : ""} hain (same subject)
//         </Typography>
//       </Box>
//       <Box sx={{ display: "flex", flexDirection: "column", gap: 0.7 }}>
//         {tickets.map((t) => (
//           <Box
//             key={t._id}
//             onClick={() => onSelect(t)}
//             sx={{
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               background: "#fff", border: "1px solid #ffe082", borderRadius: 2,
//               px: 1.5, py: 0.8, cursor: "pointer", transition: "all 0.15s",
//               "&:hover": { background: "#fff3e0", borderColor: "#ffca28", transform: "translateX(2px)" },
//             }}
//           >
//             <Box display="flex" alignItems="center" gap={1}>
//               <Typography variant="caption" fontWeight={700} color="primary">
//                 #{t.ticketId}
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {t.clientName}
//               </Typography>
//               {t.messages?.length > 0 && (
//                 <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
//                   · {t.messages.length} msg(s)
//                 </Typography>
//               )}
//             </Box>
//             <Box display="flex" gap={0.5} alignItems="center">
//               <Chip
//                 label={t.status} size="small"
//                 color={STATUS_COLOR[t.status] || "default"}
//                 sx={{ fontSize: "10px", height: 20 }}
//               />
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10, whiteSpace: "nowrap" }}>
//                 {new Date(t.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
//               </Typography>
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// // ════════════════════════════════════════════════════════════════════════════
// // MAIN ADMIN COMPONENT
// // ════════════════════════════════════════════════════════════════════════════
// const AdminHelpSupport = () => {
//   const navigate = useNavigate();

//   const [tickets,        setTickets]        = useState([]);
//   const [filtered,       setFiltered]       = useState([]);
//   const [activeTicket,   setActiveTicket]   = useState(null);
//   const [filterStatus,   setFilterStatus]   = useState("all");
//   const [filterPriority, setFilterPriority] = useState("all");
//   const [search,         setSearch]         = useState("");
//   const [loading,        setLoading]        = useState(true);
//   const [showAssign,     setShowAssign]     = useState(false);
//   const [staffList,      setStaffList]      = useState([]);
//   const [assignForm,     setAssignForm]     = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//   const [assigning,      setAssigning]      = useState(false);
//   const [showLog,        setShowLog]        = useState(false);

//   // ── Related tickets state ─────────────────────────────────────────────
//   const [relatedTickets, setRelatedTickets] = useState([]);

//   const socketRef = useRef(null);

//   // ── Fetch tickets ─────────────────────────────────────────────────────
//   const fetchTickets = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets`);
//       const data = await res.json();
//       if (res.ok) {
//         const list = Array.isArray(data.tickets) ? data.tickets : [];
//         setTickets(list);
//         setFiltered(list);
//       }
//     } catch { console.error("Failed to fetch tickets"); }
//     finally { setLoading(false); }
//   }, []);

//   useEffect(() => { fetchTickets(); }, [fetchTickets]);

//   // ── Fetch related tickets ─────────────────────────────────────────────
//   const fetchRelated = useCallback(async (ticket) => {
//     if (!ticket?.projectId || !ticket?.subject) {
//       setRelatedTickets([]);
//       return;
//     }
//     try {
//       const res = await fetch(
//         `${Url}/api/support/tickets/related/${ticket.projectId}/${encodeURIComponent(ticket.subject)}?excludeId=${ticket._id}`
//       );
//       const data = await res.json();
//       setRelatedTickets(res.ok ? (data.tickets || []) : []);
//     } catch {
//       setRelatedTickets([]);
//     }
//   }, []);

//   // activeTicket change hone par related fetch karo
//   useEffect(() => {
//     if (activeTicket) fetchRelated(activeTicket);
//     else setRelatedTickets([]);
//   }, [activeTicket, fetchRelated]);

//   // ── Socket ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const socket = socketIo(Url, { transports: ["websocket"] });
//     socketRef.current = socket;

//     socket.on("connect", () => {
//       const adminToken =
//         localStorage.getItem("adminToken") ||
//         sessionStorage.getItem("adminToken") ||
//         localStorage.getItem("token") ||
//         sessionStorage.getItem("token");

//       if (adminToken) {
//         socket.emit("joinAdmin", adminToken);
//       }
//     });

//     socket.on("support:new_ticket", (ticket) => {
//       setTickets((prev) => [ticket, ...prev]);
//       Swal.fire({
//         toast: true, position: "top-end", icon: "info",
//         showConfirmButton: false, timer: 4000,
//         title: `New Ticket: #${ticket.ticketId}`, text: ticket.subject,
//       });
//     });

//     socket.on("support:ticket_updated", (updated) => {
//       setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//       setActiveTicket((prev) => (prev?._id === updated._id ? updated : prev));
//     });

//     socket.on("support:ticket_deleted", ({ ticketId }) => {
//       setTickets((prev) => prev.filter((t) => t._id !== ticketId));
//       setActiveTicket((prev) => (prev?._id === ticketId ? null : prev));
//     });

//     socket.on("support:unread_update", ({ ticketId: tid, unreadByAdmin }) => {
//       if (unreadByAdmin === undefined) return;
//       setTickets((prev)  => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//       setFiltered((prev) => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
//     });

//     socket.on("support:new_message", ({ ticketCode, ticketId: tid }) => {
//       setActiveTicket((prev) => {
//         if (prev?._id !== tid) {
//           Swal.fire({
//             toast: true, position: "top-end", icon: "info",
//             showConfirmButton: false, timer: 2500,
//             title: `New reply on ${ticketCode}`,
//           });
//           fetchTickets();
//         }
//         return prev;
//       });
//     });

//     socket.on("support:escalated", ({ ticketCode }) => {
//       Swal.fire({
//         toast: true, position: "top-end", icon: "warning",
//         showConfirmButton: false, timer: 4000,
//         title: `Ticket Escalated: #${ticketCode}`,
//       });
//       fetchTickets();
//     });

//     return () => {
//       if (socketRef.current) {
//         socketRef.current.disconnect();
//         socketRef.current = null;
//       }
//     };
//   }, [fetchTickets]);

//   // ── Mark read ─────────────────────────────────────────────────────────
//   const markRead = useCallback(async (ticketId) => {
//     try {
//       await fetch(`${Url}/api/support/tickets/${ticketId}/mark-read`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ role: "admin" }),
//       });
//       setTickets((prev)  => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setFiltered((prev) => prev.map((t)  => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
//       setActiveTicket((prev) => prev?._id === ticketId ? { ...prev, unreadByAdmin: 0 } : prev);
//     } catch {}
//   }, []);

//   // ── Fetch staff list ──────────────────────────────────────────────────
//   const fetchStaffList = async () => {
//     try {
//       const res  = await fetch(`${Url}/management-staff`);
//       const data = await res.json();
//       if (res.ok) {
//         const raw = data.staff ?? data.data ?? data ?? [];
//         setStaffList(Array.isArray(raw) ? raw : []);
//       } else setStaffList([]);
//     } catch { setStaffList([]); }
//   };

//   // ── Filter ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     let result = [...tickets];
//     if (filterStatus   !== "all") result = result.filter((t) => t.status   === filterStatus);
//     if (filterPriority !== "all") result = result.filter((t) => t.priority === filterPriority);
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       result = result.filter((t) =>
//         t.ticketId?.toLowerCase().includes(q) ||
//         t.subject?.toLowerCase().includes(q) ||
//         t.clientName?.toLowerCase().includes(q) ||
//         t.projectId?.toLowerCase().includes(q)
//       );
//     }
//     setFiltered(result);
//   }, [filterStatus, filterPriority, search, tickets]);

//   // ── Status update ─────────────────────────────────────────────────────
//   const handleStatusChange = async (ticketId, status) => {
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ status }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//       }
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Status update failed." }); }
//   };

//   // ── Assign ────────────────────────────────────────────────────────────
//   const handleAssign = async () => {
//     if (!assignForm.staffId || !activeTicket) return;
//     setAssigning(true);
//     try {
//       const res  = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           staffId:   assignForm.staffId,
//           staffName: assignForm.staffName,
//           staffRole: assignForm.staffRole,
//           reason:    assignForm.reason,
//           adminName: "Admin",
//         }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false });
//         setActiveTicket(data.ticket);
//         setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
//         setShowAssign(false);
//         setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
//       } else Swal.fire({ icon: "error", title: "Error", text: data.message });
//     } catch { Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." }); }
//     finally { setAssigning(false); }
//   };

//   // ── Delete ────────────────────────────────────────────────────────────
//   const handleDelete = async (id) => {
//     const confirm = await Swal.fire({
//       title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.",
//       icon: "warning", showCancelButton: true,
//       confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f",
//     });
//     if (!confirm.isConfirmed) return;
//     try {
//       await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" });
//       setTickets((prev) => prev.filter((t) => t._id !== id));
//       setActiveTicket(null);
//     } catch {}
//   };

//   // ── Open ticket (from table or related banner) ────────────────────────
//   const openTicket = (ticket) => {
//     setActiveTicket(ticket);
//     setShowAssign(false);
//     setShowLog(false);
//     markRead(ticket._id);
//   };

//   const formatDate  = (d) => new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
//   const totalUnread = tickets.reduce((sum, t) => sum + (t.unreadByAdmin || 0), 0);

//   const stats = [
//     { label: "Total",       value: tickets.length,                                          color: "#1976d2", bg: "#e3f2fd" },
//     { label: "Open",        value: tickets.filter((t) => t.status === "open").length,        color: "#f57c00", bg: "#fff3e0" },
//     { label: "In Progress", value: tickets.filter((t) => t.status === "in-progress").length, color: "#0288d1", bg: "#e1f5fe" },
//     { label: "Resolved",    value: tickets.filter((t) => t.status === "resolved").length,    color: "#388e3c", bg: "#e8f5e9" },
//   ];

//   return (
//     <Box sx={{ p: 3 }}>
//       <style>{`@keyframes adminPulse{0%,100%{opacity:1}50%{opacity:0.6}}`}</style>

//       {/* Header */}
//       <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//         <Box>
//           <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
//             <HeadsetMicIcon color="primary" /> Help & Support Tickets
//             {totalUnread > 0 && (
//               <Chip label={`${totalUnread} unread`} size="small" color="error" sx={{ fontWeight: 700, animation: "adminPulse 1.5s ease infinite" }} />
//             )}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">Manage and assign client support requests</Typography>
//         </Box>
//       </Box>

//       {/* Stats */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {stats.map((s) => (
//           <Grid item xs={6} md={3} key={s.label}>
//             <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
//               <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
//                 <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
//                 <Typography variant="body2" color="text.secondary">{s.label}</Typography>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Filters */}
//       <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
//         <TextField
//           size="small" placeholder="Search ticket, client, project..."
//           value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: 260 }}
//           InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
//         />
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Status</InputLabel>
//           <Select label="Status" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//             <MenuItem value="all">All Status</MenuItem>
//             <MenuItem value="open">Open</MenuItem>
//             <MenuItem value="in-progress">In Progress</MenuItem>
//             <MenuItem value="resolved">Resolved</MenuItem>
//             <MenuItem value="closed">Closed</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel>Priority</InputLabel>
//           <Select label="Priority" value={filterPriority} onChange={(e) => setFilterPriority(e.target.value)}>
//             <MenuItem value="all">All Priority</MenuItem>
//             <MenuItem value="high">High</MenuItem>
//             <MenuItem value="medium">Medium</MenuItem>
//             <MenuItem value="low">Low</MenuItem>
//           </Select>
//         </FormControl>
//         <Tooltip title="Refresh">
//           <IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton>
//         </Tooltip>
//       </Box>

//       {/* Table */}
//       {loading ? (
//         <Box sx={{ textAlign: "center", py: 8 }}>
//           <CircularProgress />
//           <Typography mt={2} color="text.secondary">Loading tickets...</Typography>
//         </Box>
//       ) : filtered.length === 0 ? (
//         <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
//           <FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} />
//           <Typography>No tickets found.</Typography>
//         </Box>
//       ) : (
//         <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
//           <Box sx={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ background: "#f5f5f5" }}>
//                   {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map((h) => (
//                     <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555" }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((ticket, idx) => {
//                   const hasUnread = (ticket.unreadByAdmin || 0) > 0;
//                   return (
//                     <tr key={ticket._id}
//                       style={{ background: hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa", cursor: "pointer", transition: "background 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
//                       onMouseLeave={(e) => (e.currentTarget.style.background = hasUnread ? "#fff8f8" : idx % 2 === 0 ? "#fff" : "#fafafa")}
//                     >
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="caption" fontWeight={700} color="primary">#{ticket.ticketId}</Typography>
//                         {hasUnread && <UnreadDot count={ticket.unreadByAdmin} />}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
//                         <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}>
//                         <Typography variant="body2" noWrap>{ticket.subject === "Other" ? ticket.customSubject : ticket.subject}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         {ticket.assignedTo?.id ? (
//                           <Box display="flex" alignItems="center" gap={0.5}>
//                             <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>
//                               {ticket.assignedTo.name?.charAt(0)}
//                             </Avatar>
//                             <Typography variant="caption">{ticket.assignedTo.name}</Typography>
//                           </Box>
//                         ) : (
//                           <Typography variant="caption" color="text.secondary">Unassigned</Typography>
//                         )}
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
//                         <Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography>
//                       </td>
//                       <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
//                         <Box display="flex" gap={0.5}>
//                           <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => openTicket(ticket)}>
//                             View
//                           </button>
//                           <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 11 }}
//                             onClick={() => handleDelete(ticket._id)}>
//                             Del
//                           </button>
//                         </Box>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </Box>
//         </Paper>
//       )}

//       {/* ── Ticket Detail Dialog ─────────────────────────────────────── */}
//       <Dialog
//         open={!!activeTicket}
//         onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }}
//         maxWidth="md" fullWidth
//       >
//         {activeTicket && (
//           <>
//             <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//               <Box>
//                 <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
//                 <Typography variant="h6" fontWeight={700}>
//                   {activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}
//                 </Typography>
//               </Box>
//               <Box display="flex" gap={1}>
//                 <Tooltip title="Escalation Log">
//                   <IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small">
//                     <HistoryIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <Tooltip title="Assign to Staff">
//                   <IconButton onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }} size="small" color="primary">
//                     <AssignmentIndIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//                 <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }} size="small">
//                   <CloseIcon />
//                 </IconButton>
//               </Box>
//             </DialogTitle>

//             <Divider />

//             {/* Info Bar */}
//             <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
//               <Box display="flex" alignItems="center" gap={0.5}>
//                 <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
//                 <Typography variant="caption">
//                   <b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}
//                 </Typography>
//               </Box>
//               <Typography variant="caption" color="text.secondary">
//                 Project: <b>{activeTicket.projectName || activeTicket.projectId}</b>
//               </Typography>
//               <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />
//               {activeTicket.assignedTo?.id && (
//                 <Box display="flex" alignItems="center" gap={0.5}>
//                   <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
//                   <Typography variant="caption" color="primary">
//                     <b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})
//                   </Typography>
//                 </Box>
//               )}
//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select
//                   value={activeTicket.status}
//                   onChange={(e) => handleStatusChange(activeTicket._id, e.target.value)}
//                   sx={{ fontSize: "12px", height: "28px" }}
//                 >
//                   <MenuItem value="open">Open</MenuItem>
//                   <MenuItem value="in-progress">In Progress</MenuItem>
//                   <MenuItem value="resolved">Resolved</MenuItem>
//                   <MenuItem value="closed">Closed</MenuItem>
//                 </Select>
//               </FormControl>

//               {/* ── View Project button — only for Refund Issue ── */}
//               {activeTicket.subject === "Refund Issue" && activeTicket.projectId && (
//                 <Tooltip title={`Project #${activeTicket.projectId} open karo`}>
//                   <Button
//                     size="small"
//                     variant="contained"
//                     color="error"
//                     startIcon={<LaunchIcon sx={{ fontSize: "13px !important" }} />}
//                     onClick={() => {
//                       setActiveTicket(null);
//                       setShowAssign(false);
//                       setShowLog(false);
//                       setRelatedTickets([]);
//                       navigate(`/dashboard/project/${activeTicket.projectId}`);
//                     }}
//                     sx={{
//                       fontSize: "11px",
//                       height: 28,
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                       whiteSpace: "nowrap",
//                       boxShadow: "none",
//                       "&:hover": { boxShadow: "0 2px 8px rgba(211,47,47,0.35)" },
//                     }}
//                   >
//                     View Project
//                   </Button>
//                 </Tooltip>
//               )}
//             </Box>

//             <DialogContent sx={{ p: 0 }}>
//               {/* ── Related Tickets Banner ──────────────────────────── */}
//               <RelatedTicketsBanner
//                 tickets={relatedTickets}
//                 onSelect={(t) => openTicket(t)}
//               />

//               {/* Assign Panel */}
//               {showAssign && (
//                 <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
//                     <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Assign Ticket to Management Staff
//                   </Typography>
//                   <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
//                     <FormControl size="small" sx={{ minWidth: 200 }}>
//                       <InputLabel>Select Staff</InputLabel>
//                       <Select
//                         label="Select Staff"
//                         value={assignForm.staffId}
//                         onChange={(e) => {
//                           const s = staffList.find((x) => x._id === e.target.value);
//                           setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" });
//                         }}
//                       >
//                         <MenuItem value="">-- Select --</MenuItem>
//                         {staffList.map((s) => (
//                           <MenuItem key={s._id} value={s._id}>{s.name} ({s.roleName || s.slug || "staff"})</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                     <FormControl size="small" sx={{ minWidth: 160 }}>
//                       <InputLabel>Role</InputLabel>
//                       <Select label="Role" value={assignForm.staffRole} onChange={(e) => setAssignForm({ ...assignForm, staffRole: e.target.value })}>
//                         <MenuItem value="staff">Staff</MenuItem>
//                         <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
//                       </Select>
//                     </FormControl>
//                     <TextField
//                       size="small" label="Reason (optional)"
//                       value={assignForm.reason}
//                       onChange={(e) => setAssignForm({ ...assignForm, reason: e.target.value })}
//                       sx={{ minWidth: 180 }}
//                     />
//                     <Button variant="contained" size="small" onClick={handleAssign}
//                       disabled={!assignForm.staffId || assigning} startIcon={<AssignmentIndIcon />}>
//                       {assigning ? "Assigning..." : "Assign"}
//                     </Button>
//                     <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
//                   </Box>
//                 </Box>
//               )}

//               {/* Escalation Log */}
//               {showLog && (
//                 <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
//                   <Typography variant="subtitle2" fontWeight={700} mb={1}>
//                     <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />
//                     Escalation Log
//                   </Typography>
//                   {!activeTicket.escalationLog?.length ? (
//                     <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
//                   ) : (
//                     activeTicket.escalationLog.map((log, i) => (
//                       <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
//                         <b>{log.fromName}</b> → <b>{log.toName}</b>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                           {log.reason || "N/A"} · {formatDate(log.escalatedAt)}
//                         </Typography>
//                       </Box>
//                     ))
//                   )}
//                 </Box>
//               )}

//               {/* Chat */}
//               <TicketChat
//                 ticket={activeTicket}
//                 onMarkRead={markRead}
//                 onUpdate={(updated) => {
//                   setActiveTicket(updated);
//                   setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
//                 }}
//               />
//             </DialogContent>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default AdminHelpSupport;











"use client";

import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box, Typography, Paper, TextField, Select, MenuItem,
  FormControl, InputLabel, Chip, IconButton, Dialog,
  DialogTitle, DialogContent, CircularProgress, Grid,
  Card, CardContent, Divider, Tooltip, InputAdornment,
  Button, Avatar,
} from "@mui/material";
import SendIcon          from "@mui/icons-material/Send";
import SearchIcon        from "@mui/icons-material/Search";
import RefreshIcon       from "@mui/icons-material/Refresh";
import CloseIcon         from "@mui/icons-material/Close";
import FolderOpenIcon    from "@mui/icons-material/FolderOpen";
import HeadsetMicIcon    from "@mui/icons-material/HeadsetMic";
import PersonIcon        from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import HistoryIcon       from "@mui/icons-material/History";
import WarningAmberIcon  from "@mui/icons-material/WarningAmber";
import LaunchIcon        from "@mui/icons-material/Launch";
import Swal              from "sweetalert2";
import { Url }           from "src/url/url";
import { io as socketIo } from "socket.io-client";
import { useNavigate }   from "react-router-dom";

const STATUS_COLOR   = { open: "warning", "in-progress": "info", resolved: "success", closed: "default" };
const PRIORITY_COLOR = { high: "error", medium: "warning", low: "success" };

// ── Unread dot badge ──────────────────────────────────────────────────────────
const UnreadDot = ({ count }) => {
  if (!count || count <= 0) return null;
  return (
    <span style={{
      background: "#f44336", color: "#fff", borderRadius: 50,
      padding: "1px 7px", fontSize: 10, fontWeight: 700,
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      marginLeft: 6, animation: "adminPulse 1.5s ease infinite",
    }}>
      {count > 99 ? "99+" : count}
    </span>
  );
};

// ─── Ticket Chat ──────────────────────────────────────────────────────────────
const TicketChat = ({ ticket, onUpdate, onMarkRead }) => {
  const [replyText, setReplyText] = useState("");
  const [sending,   setSending]   = useState(false);
  const chatEndRef                = useRef(null);
  const isClosed = ticket.status === "closed";

  useEffect(() => {
    setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 80);
  }, [ticket.messages?.length]);

  useEffect(() => {
    if (ticket?._id && (ticket?.unreadByAdmin || 0) > 0) onMarkRead?.(ticket._id);
  }, [ticket?._id]);

  const handleReply = async () => {
    if (!replyText.trim() || sending) return;
    setSending(true);
    try {
      const res = await fetch(`${Url}/api/support/tickets/${ticket._id}/reply`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sender: "admin", senderId: "admin", senderName: "Support Team", message: replyText }),
      });
      const data = await res.json();
      if (res.ok) { setReplyText(""); onUpdate(data.ticket); }
    } catch {
      Swal.fire({ icon: "error", title: "Error", text: "Reply send nahi hua." });
    } finally { setSending(false); }
  };

  const fmtTime = (d) => new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  const fmtDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

  return (
    <Box>
      <Box sx={{ height: 340, overflowY: "auto", background: "#f5f7fa", px: 2, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
        {Array.isArray(ticket.messages) && ticket.messages.map((msg, i) => {
          const isAdmin  = msg.sender === "admin";
          const isSystem = msg.senderName === "System";
          if (isSystem) return (
            <Box key={i} sx={{ textAlign: "center" }}>
              <Typography variant="caption" sx={{ background: "#e2e8f0", px: 2, py: 0.5, borderRadius: 50, color: "#64748b" }}>
                {msg.message}
              </Typography>
            </Box>
          );
          return (
            <Box key={i} sx={{ display: "flex", justifyContent: isAdmin ? "flex-end" : "flex-start" }}>
              {!isAdmin && (
                <Avatar sx={{ width: 28, height: 28, fontSize: 12, mr: 1, alignSelf: "flex-end", bgcolor: "#e3f2fd", color: "#1976d2" }}>
                  {(msg.senderName || "C").charAt(0).toUpperCase()}
                </Avatar>
              )}
              <Box sx={{ maxWidth: "74%" }}>
                {!isAdmin && (
                  <Typography variant="caption" sx={{ ml: 0.5, color: "#94a3b8", fontSize: 10 }}>{msg.senderName}</Typography>
                )}
                <Box sx={{
                  px: 2, py: 1.5,
                  borderRadius: isAdmin ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                  bgcolor: isAdmin ? "#1976d2" : "#fff",
                  color: isAdmin ? "#fff" : "inherit",
                  border: !isAdmin ? "1px solid #e0e0e0" : "none",
                  boxShadow: 1,
                }}>
                  <Typography variant="body2">{msg.message}</Typography>
                  <Typography sx={{ fontSize: 10, textAlign: "right", mt: 0.5, opacity: 0.7 }}>
                    {fmtDate(msg.createdAt)} · {fmtTime(msg.createdAt)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
        <div ref={chatEndRef} />
      </Box>

      <Divider />

      {isClosed ? (
        <Box sx={{ px: 2, py: 1.5, textAlign: "center", bgcolor: "#fafafa" }}>
          <Typography variant="caption" color="text.secondary">🔒 Ticket closed.</Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", gap: 1.5, px: 2, py: 1.5, alignItems: "center" }}>
          <TextField
            fullWidth size="small"
            placeholder="Client ko reply karein..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && handleReply()}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "50px" } }}
          />
          <IconButton
            color="primary" onClick={handleReply}
            disabled={!replyText.trim() || sending}
            sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" }, "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" } }}
          >
            <SendIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

// ─── Related Tickets Banner (dialog ke andar) ─────────────────────────────────
const RelatedTicketsBanner = ({ tickets, onSelect }) => {
  if (!tickets || tickets.length === 0) return null;
  return (
    <Box sx={{
      px: 2.5, py: 1.5,
      background: "linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)",
      borderBottom: "1px solid #ffe082",
    }}>
      <Box display="flex" alignItems="center" gap={0.8} mb={1}>
        <WarningAmberIcon sx={{ fontSize: 15, color: "#e65100" }} />
        <Typography variant="caption" fontWeight={700} color="#e65100">
          Is project pe {tickets.length} aur active ticket{tickets.length > 1 ? "s" : ""} hain (same subject)
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.7 }}>
        {tickets.map((t) => (
          <Box
            key={t._id}
            onClick={() => onSelect(t)}
            sx={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              background: "#fff", border: "1px solid #ffe082", borderRadius: 2,
              px: 1.5, py: 0.8, cursor: "pointer", transition: "all 0.15s",
              "&:hover": { background: "#fff3e0", borderColor: "#ffca28", transform: "translateX(2px)" },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" fontWeight={700} color="primary">#{t.ticketId}</Typography>
              <Typography variant="caption" color="text.secondary">{t.clientName}</Typography>
              {t.messages?.length > 0 && (
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                  · {t.messages.length} msg(s)
                </Typography>
              )}
            </Box>
            <Box display="flex" gap={0.5} alignItems="center">
              <Chip label={t.status} size="small" color={STATUS_COLOR[t.status] || "default"} sx={{ fontSize: "10px", height: 20 }} />
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10, whiteSpace: "nowrap" }}>
                {new Date(t.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

// ─── ✅ NEW: Table row ke andar inline related tickets ────────────────────────
// Badge click karne par expand hoti hai mini-list jisme same project+subject ke tickets dikhte hain
const RelatedTicketsInline = ({ siblings, onSelect }) => {
  const [expanded, setExpanded] = useState(false);
  if (!siblings || siblings.length === 0) return null;

  return (
    <Box sx={{ mt: 0.5 }}>
      {/* Orange badge — click se expand/collapse */}
      <Box
        onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
        sx={{
          display: "inline-flex", alignItems: "center", gap: 0.4,
          background: "#fff3e0", color: "#e65100",
          border: "1px solid #ffcc80", borderRadius: 1.5,
          px: 0.8, py: 0.3, fontSize: 10, fontWeight: 700,
          cursor: "pointer", whiteSpace: "nowrap", lineHeight: 1.5,
          userSelect: "none",
          "&:hover": { background: "#ffe0b2", borderColor: "#ffa726" },
        }}
      >
        <WarningAmberIcon sx={{ fontSize: 11 }} />
        {siblings.length} related ticket{siblings.length > 1 ? "s" : ""}
        <span style={{ fontSize: 9, marginLeft: 2 }}>{expanded ? "▲" : "▼"}</span>
      </Box>

      {/* Expanded: sibling tickets ki mini list */}
      {expanded && (
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            mt: 0.6,
            border: "1px solid #ffe082",
            borderRadius: 1.5,
            overflow: "hidden",
            background: "#fffdf5",
            minWidth: 230,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            position: "relative",
            zIndex: 10,
          }}
        >
          {siblings.map((t, i) => (
            <Box
              key={t._id}
              onClick={() => { setExpanded(false); onSelect(t); }}
              sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                px: 1.2, py: 0.8,
                borderTop: i === 0 ? "none" : "1px solid #fff3cd",
                cursor: "pointer", gap: 1,
                "&:hover": { background: "#fff3e0" },
              }}
            >
              <Box display="flex" alignItems="center" gap={0.8} sx={{ minWidth: 0 }}>
                <Typography variant="caption" fontWeight={700} color="primary" sx={{ whiteSpace: "nowrap" }}>
                  #{t.ticketId}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: 90, fontSize: 10 }}>
                  {t.clientName}
                </Typography>
                {/* Unread badge for sibling */}
                {(t.unreadByAdmin || 0) > 0 && (
                  <span style={{
                    background: "#f44336", color: "#fff", borderRadius: 50,
                    padding: "0px 5px", fontSize: 9, fontWeight: 700,
                    display: "inline-flex", alignItems: "center",
                  }}>
                    {t.unreadByAdmin}
                  </span>
                )}
              </Box>
              <Chip
                label={t.status} size="small"
                color={STATUS_COLOR[t.status] || "default"}
                sx={{ fontSize: "9px", height: 18, flexShrink: 0 }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

// ════════════════════════════════════════════════════════════════════════════
// MAIN ADMIN COMPONENT
// ════════════════════════════════════════════════════════════════════════════
const AdminHelpSupport = () => {
  const navigate = useNavigate();

  const [tickets,        setTickets]        = useState([]);
  const [filtered,       setFiltered]       = useState([]);
  const [activeTicket,   setActiveTicket]   = useState(null);
  const [filterStatus,   setFilterStatus]   = useState("all");
  const [filterPriority, setFilterPriority] = useState("all");
  const [search,         setSearch]         = useState("");
  const [loading,        setLoading]        = useState(true);
  const [showAssign,     setShowAssign]     = useState(false);
  const [staffList,      setStaffList]      = useState([]);
  const [assignForm,     setAssignForm]     = useState({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
  const [assigning,      setAssigning]      = useState(false);
  const [showLog,        setShowLog]        = useState(false);

  // ── Related tickets states ────────────────────────────────────────────
  const [relatedTickets, setRelatedTickets] = useState([]);
  // ✅ NEW: { "projectId||subject" -> [ticketObj, ...] }  — client-side grouping
  const [relatedGroups,  setRelatedGroups]  = useState({});

  const socketRef = useRef(null);

  // ── Fetch tickets ─────────────────────────────────────────────────────
  const fetchTickets = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${Url}/api/support/tickets`);
      const data = await res.json();
      if (res.ok) {
        const list = Array.isArray(data.tickets) ? data.tickets : [];
        setTickets(list);
        setFiltered(list);
      }
    } catch { console.error("Failed to fetch tickets"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchTickets(); }, [fetchTickets]);

  // ── Fetch related tickets (dialog banner ke liye — API call) ──────────
  const fetchRelated = useCallback(async (ticket) => {
    if (!ticket?.projectId || !ticket?.subject) { setRelatedTickets([]); return; }
    try {
      const res = await fetch(
        `${Url}/api/support/tickets/related/${ticket.projectId}/${encodeURIComponent(ticket.subject)}?excludeId=${ticket._id}`
      );
      const data = await res.json();
      setRelatedTickets(res.ok ? (data.tickets || []) : []);
    } catch { setRelatedTickets([]); }
  }, []);

  useEffect(() => {
    if (activeTicket) fetchRelated(activeTicket);
    else setRelatedTickets([]);
  }, [activeTicket, fetchRelated]);

  // ── Socket ────────────────────────────────────────────────────────────
  useEffect(() => {
    const socket = socketIo(Url, { transports: ["websocket"] });
    socketRef.current = socket;

    socket.on("connect", () => {
      const adminToken =
        localStorage.getItem("adminToken") ||
        sessionStorage.getItem("adminToken") ||
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");
      if (adminToken) socket.emit("joinAdmin", adminToken);
    });

    socket.on("support:new_ticket", (ticket) => {
      setTickets((prev) => [ticket, ...prev]);
      Swal.fire({ toast: true, position: "top-end", icon: "info", showConfirmButton: false, timer: 4000, title: `New Ticket: #${ticket.ticketId}`, text: ticket.subject });
    });

    socket.on("support:ticket_updated", (updated) => {
      setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
      setActiveTicket((prev) => (prev?._id === updated._id ? updated : prev));
    });

    socket.on("support:ticket_deleted", ({ ticketId }) => {
      setTickets((prev) => prev.filter((t) => t._id !== ticketId));
      setActiveTicket((prev) => (prev?._id === ticketId ? null : prev));
    });

    socket.on("support:unread_update", ({ ticketId: tid, unreadByAdmin }) => {
      if (unreadByAdmin === undefined) return;
      setTickets((prev)  => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
      setFiltered((prev) => prev.map((t) => (t._id === tid ? { ...t, unreadByAdmin } : t)));
    });

    socket.on("support:new_message", ({ ticketCode, ticketId: tid }) => {
      setActiveTicket((prev) => {
        if (prev?._id !== tid) {
          Swal.fire({ toast: true, position: "top-end", icon: "info", showConfirmButton: false, timer: 2500, title: `New reply on ${ticketCode}` });
          fetchTickets();
        }
        return prev;
      });
    });

    socket.on("support:escalated", ({ ticketCode }) => {
      Swal.fire({ toast: true, position: "top-end", icon: "warning", showConfirmButton: false, timer: 4000, title: `Ticket Escalated: #${ticketCode}` });
      fetchTickets();
    });

    return () => { if (socketRef.current) { socketRef.current.disconnect(); socketRef.current = null; } };
  }, [fetchTickets]);

  // ── Mark read ─────────────────────────────────────────────────────────
  const markRead = useCallback(async (ticketId) => {
    try {
      await fetch(`${Url}/api/support/tickets/${ticketId}/mark-read`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role: "admin" }),
      });
      setTickets((prev)  => prev.map((t) => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
      setFiltered((prev) => prev.map((t) => t._id === ticketId ? { ...t, unreadByAdmin: 0 } : t));
      setActiveTicket((prev) => prev?._id === ticketId ? { ...prev, unreadByAdmin: 0 } : prev);
    } catch {}
  }, []);

  // ── Fetch staff list ──────────────────────────────────────────────────
  const fetchStaffList = async () => {
    try {
      const res  = await fetch(`${Url}/management-staff`);
      const data = await res.json();
      if (res.ok) {
        const raw = data.staff ?? data.data ?? data ?? [];
        setStaffList(Array.isArray(raw) ? raw : []);
      } else setStaffList([]);
    } catch { setStaffList([]); }
  };

  // ── Filter + ✅ Build relatedGroups (client-side, no extra API needed) ─
  useEffect(() => {
    let result = [...tickets];
    if (filterStatus   !== "all") result = result.filter((t) => t.status   === filterStatus);
    if (filterPriority !== "all") result = result.filter((t) => t.priority === filterPriority);
    if (search.trim()) {
      const q = search.toLowerCase();
      result = result.filter((t) =>
        t.ticketId?.toLowerCase().includes(q) ||
        t.subject?.toLowerCase().includes(q) ||
        t.clientName?.toLowerCase().includes(q) ||
        t.projectId?.toLowerCase().includes(q)
      );
    }
    setFiltered(result);

    // ✅ Group sab tickets by "projectId||subject" — full objects store karo
    const groups = {};
    tickets.forEach((t) => {
      const key = `${t.projectId}||${t.subject}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(t);
    });
    setRelatedGroups(groups);
  }, [filterStatus, filterPriority, search, tickets]);

  // ── Status update ─────────────────────────────────────────────────────
  const handleStatusChange = async (ticketId, status) => {
    try {
      const res  = await fetch(`${Url}/api/support/tickets/${ticketId}/status`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      });
      const data = await res.json();
      if (res.ok) {
        setActiveTicket(data.ticket);
        setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
      }
    } catch { Swal.fire({ icon: "error", title: "Error", text: "Status update failed." }); }
  };

  // ── Assign ────────────────────────────────────────────────────────────
  const handleAssign = async () => {
    if (!assignForm.staffId || !activeTicket) return;
    setAssigning(true);
    try {
      const res  = await fetch(`${Url}/api/support/tickets/${activeTicket._id}/assign`, {
        method: "PATCH", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          staffId: assignForm.staffId, staffName: assignForm.staffName,
          staffRole: assignForm.staffRole, reason: assignForm.reason, adminName: "Admin",
        }),
      });
      const data = await res.json();
      if (res.ok) {
        Swal.fire({ icon: "success", title: "Assigned!", text: `Ticket assigned to ${assignForm.staffName}`, timer: 2500, showConfirmButton: false });
        setActiveTicket(data.ticket);
        setTickets((prev) => prev.map((t) => (t._id === data.ticket._id ? data.ticket : t)));
        setShowAssign(false);
        setAssignForm({ staffId: "", staffName: "", staffRole: "staff", reason: "" });
      } else Swal.fire({ icon: "error", title: "Error", text: data.message });
    } catch { Swal.fire({ icon: "error", title: "Error", text: "Assignment failed." }); }
    finally { setAssigning(false); }
  };

  // ── Delete ────────────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete ticket?", text: "Yeh action undo nahi ho sakti.",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Haan, delete karo", confirmButtonColor: "#d32f2f",
    });
    if (!confirm.isConfirmed) return;
    try {
      await fetch(`${Url}/api/support/tickets/${id}`, { method: "DELETE" });
      setTickets((prev) => prev.filter((t) => t._id !== id));
      setActiveTicket(null);
    } catch {}
  };

  // ── Open ticket ───────────────────────────────────────────────────────
  const openTicket = (ticket) => {
    setActiveTicket(ticket);
    setShowAssign(false);
    setShowLog(false);
    markRead(ticket._id);
  };

  const formatDate  = (d) => new Date(d).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  const totalUnread = tickets.reduce((sum, t) => sum + (t.unreadByAdmin || 0), 0);

  const stats = [
    { label: "Total",       value: tickets.length,                                          color: "#1976d2", bg: "#e3f2fd" },
    { label: "Open",        value: tickets.filter((t) => t.status === "open").length,        color: "#f57c00", bg: "#fff3e0" },
    { label: "In Progress", value: tickets.filter((t) => t.status === "in-progress").length, color: "#0288d1", bg: "#e1f5fe" },
    { label: "Resolved",    value: tickets.filter((t) => t.status === "resolved").length,    color: "#388e3c", bg: "#e8f5e9" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <style>{`@keyframes adminPulse{0%,100%{opacity:1}50%{opacity:0.6}}`}</style>

      {/* Header */}
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
        <Box>
          <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1}>
            <HeadsetMicIcon color="primary" /> Help & Support Tickets
            {totalUnread > 0 && (
              <Chip label={`${totalUnread} unread`} size="small" color="error" sx={{ fontWeight: 700, animation: "adminPulse 1.5s ease infinite" }} />
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary">Manage and assign client support requests</Typography>
        </Box>
      </Box>

      {/* Stats */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {stats.map((s) => (
          <Grid item xs={6} md={3} key={s.label}>
            <Card elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, background: s.bg }}>
              <CardContent sx={{ textAlign: "center", py: 2, "&:last-child": { pb: 2 } }}>
                <Typography variant="h4" fontWeight={700} color={s.color}>{s.value}</Typography>
                <Typography variant="body2" color="text.secondary">{s.label}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Filters */}
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2, alignItems: "center" }}>
        <TextField
          size="small" placeholder="Search ticket, client, project..."
          value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: 260 }}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
        />
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Status</InputLabel>
          <Select label="Status" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <MenuItem value="all">All Status</MenuItem>
            <MenuItem value="open">Open</MenuItem>
            <MenuItem value="in-progress">In Progress</MenuItem>
            <MenuItem value="resolved">Resolved</MenuItem>
            <MenuItem value="closed">Closed</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Priority</InputLabel>
          <Select label="Priority" value={filterPriority} onChange={(e) => setFilterPriority(e.target.value)}>
            <MenuItem value="all">All Priority</MenuItem>
            <MenuItem value="high">High</MenuItem>
            <MenuItem value="medium">Medium</MenuItem>
            <MenuItem value="low">Low</MenuItem>
          </Select>
        </FormControl>
        <Tooltip title="Refresh">
          <IconButton onClick={fetchTickets} color="primary"><RefreshIcon /></IconButton>
        </Tooltip>
      </Box>

      {/* Table */}
      {loading ? (
        <Box sx={{ textAlign: "center", py: 8 }}>
          <CircularProgress />
          <Typography mt={2} color="text.secondary">Loading tickets...</Typography>
        </Box>
      ) : filtered.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
          <FolderOpenIcon sx={{ fontSize: 48, mb: 1 }} />
          <Typography>No tickets found.</Typography>
        </Box>
      ) : (
        <Paper elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 3, overflow: "hidden" }}>
          <Box sx={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ background: "#f5f5f5" }}>
                  {["Ticket ID", "Client", "Project", "Subject", "Priority", "Status", "Assigned To", "Date", "Actions"].map((h) => (
                    <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontWeight: 600, whiteSpace: "nowrap", borderBottom: "1px solid #e0e0e0", color: "#555" }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((ticket, idx) => {
                  const hasUnread = (ticket.unreadByAdmin || 0) > 0;

                  // ✅ Siblings = same project + same subject ke baaki tickets (self exclude)
                  const groupKey = `${ticket.projectId}||${ticket.subject}`;
                  const siblings = (relatedGroups[groupKey] || []).filter((t) => t._id !== ticket._id);
                  const isRelated = siblings.length > 0;

                  return (
                    <tr
                      key={ticket._id}
                      style={{
                        // ✅ Related tickets ka row light yellow background
                        background: hasUnread ? "#fff8f8" : isRelated ? "#fffbf0" : idx % 2 === 0 ? "#fff" : "#fafafa",
                        cursor: "pointer",
                        transition: "background 0.15s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7ff")}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = hasUnread
                          ? "#fff8f8"
                          : isRelated ? "#fffbf0"
                          : idx % 2 === 0 ? "#fff" : "#fafafa";
                      }}
                    >
                      {/* ── Ticket ID + unread dot + ✅ related badge with expandable list ── */}
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", verticalAlign: "top" }}>
                        <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.3}>
                          <Typography variant="caption" fontWeight={700} color="primary">
                            #{ticket.ticketId}
                          </Typography>
                          {hasUnread && <UnreadDot count={ticket.unreadByAdmin} />}
                        </Box>
                        {/* ✅ Inline expandable sibling list */}
                        <RelatedTicketsInline siblings={siblings} onSelect={openTicket} />
                      </td>

                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        <Typography variant="body2" fontWeight={500}>{ticket.clientName}</Typography>
                        <Typography variant="caption" color="text.secondary">{ticket.clientEmail}</Typography>
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        <Typography variant="body2">{ticket.projectName || ticket.projectId}</Typography>
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", maxWidth: 160 }}>
                        <Typography variant="body2" noWrap>
                          {ticket.subject === "Other" ? ticket.customSubject : ticket.subject}
                        </Typography>
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        <Chip label={ticket.priority} size="small" color={PRIORITY_COLOR[ticket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        <Chip label={ticket.status} size="small" color={STATUS_COLOR[ticket.status] || "default"} sx={{ textTransform: "capitalize", fontSize: "11px" }} />
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        {ticket.assignedTo?.id ? (
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <Avatar sx={{ width: 20, height: 20, fontSize: 10, bgcolor: "#e3f2fd", color: "#1976d2" }}>
                              {ticket.assignedTo.name?.charAt(0)}
                            </Avatar>
                            <Typography variant="caption">{ticket.assignedTo.name}</Typography>
                          </Box>
                        ) : (
                          <Typography variant="caption" color="text.secondary">Unassigned</Typography>
                        )}
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap" }}>
                        <Typography variant="caption" color="text.secondary">{formatDate(ticket.createdAt)}</Typography>
                      </td>
                      <td style={{ padding: "12px 14px", borderBottom: "1px solid #f0f0f0" }}>
                        <Box display="flex" gap={0.5}>
                          <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }} onClick={() => openTicket(ticket)}>
                            View
                          </button>
                          <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 11 }} onClick={() => handleDelete(ticket._id)}>
                            Del
                          </button>
                        </Box>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Box>
        </Paper>
      )}

      {/* ── Ticket Detail Dialog ─────────────────────────────────────── */}
      <Dialog
        open={!!activeTicket}
        onClose={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }}
        maxWidth="md" fullWidth
      >
        {activeTicket && (
          <>
            <DialogTitle sx={{ pb: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box>
                <Typography variant="caption" color="text.secondary">#{activeTicket.ticketId}</Typography>
                <Typography variant="h6" fontWeight={700}>
                  {activeTicket.subject === "Other" ? activeTicket.customSubject : activeTicket.subject}
                </Typography>
              </Box>
              <Box display="flex" gap={1}>
                <Tooltip title="Escalation Log">
                  <IconButton onClick={() => { setShowLog(true); setShowAssign(false); }} size="small">
                    <HistoryIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Assign to Staff">
                  <IconButton onClick={() => { fetchStaffList(); setShowAssign(true); setShowLog(false); }} size="small" color="primary">
                    <AssignmentIndIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <IconButton onClick={() => { setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]); }} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>

            <Divider />

            {/* Info Bar */}
            <Box sx={{ px: 3, py: 1.5, background: "#f8f9fa", display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <PersonIcon fontSize="small" sx={{ color: "text.secondary" }} />
                <Typography variant="caption">
                  <b>{activeTicket.clientName}</b> · {activeTicket.clientEmail}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary">
                Project: <b>{activeTicket.projectName || activeTicket.projectId}</b>
              </Typography>
              <Chip label={activeTicket.priority} size="small" color={PRIORITY_COLOR[activeTicket.priority] || "default"} sx={{ textTransform: "capitalize", fontSize: "10px" }} />
              {activeTicket.assignedTo?.id && (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <AssignmentIndIcon fontSize="small" sx={{ color: "#1976d2" }} />
                  <Typography variant="caption" color="primary">
                    <b>{activeTicket.assignedTo.name}</b> ({activeTicket.assignedTo.role})
                  </Typography>
                </Box>
              )}
              <FormControl size="small" sx={{ minWidth: 130 }}>
                <Select
                  value={activeTicket.status}
                  onChange={(e) => handleStatusChange(activeTicket._id, e.target.value)}
                  sx={{ fontSize: "12px", height: "28px" }}
                >
                  <MenuItem value="open">Open</MenuItem>
                  <MenuItem value="in-progress">In Progress</MenuItem>
                  <MenuItem value="resolved">Resolved</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                </Select>
              </FormControl>

              {/* View Project button — only for Refund Issue */}
              {activeTicket.subject === "Refund Issue" && activeTicket.projectId && (
                <Tooltip title={`Project #${activeTicket.projectId} open karo`}>
                  <Button
                    size="small" variant="contained" color="error"
                    startIcon={<LaunchIcon sx={{ fontSize: "13px !important" }} />}
                    onClick={() => {
                      setActiveTicket(null); setShowAssign(false); setShowLog(false); setRelatedTickets([]);
                      navigate(`/dashboard/project/${activeTicket.projectId}`);
                    }}
                    sx={{ fontSize: "11px", height: 28, borderRadius: 2, textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", boxShadow: "none", "&:hover": { boxShadow: "0 2px 8px rgba(211,47,47,0.35)" } }}
                  >
                    View Project
                  </Button>
                </Tooltip>
              )}
            </Box>

            <DialogContent sx={{ p: 0 }}>
              {/* Related Tickets Banner */}
              <RelatedTicketsBanner tickets={relatedTickets} onSelect={(t) => openTicket(t)} />

              {/* Assign Panel */}
              {showAssign && (
                <Box sx={{ p: 2, background: "#e8f4ff", borderBottom: "1px solid #bee3f8" }}>
                  <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
                    <AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />
                    Assign Ticket to Management Staff
                  </Typography>
                  <Box display="flex" gap={1.5} flexWrap="wrap" alignItems="flex-end">
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <InputLabel>Select Staff</InputLabel>
                      <Select
                        label="Select Staff" value={assignForm.staffId}
                        onChange={(e) => {
                          const s = staffList.find((x) => x._id === e.target.value);
                          setAssignForm({ ...assignForm, staffId: e.target.value, staffName: s?.name || "" });
                        }}
                      >
                        <MenuItem value="">-- Select --</MenuItem>
                        {staffList.map((s) => (
                          <MenuItem key={s._id} value={s._id}>{s.name} ({s.roleName || s.slug || "staff"})</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                      <InputLabel>Role</InputLabel>
                      <Select label="Role" value={assignForm.staffRole} onChange={(e) => setAssignForm({ ...assignForm, staffRole: e.target.value })}>
                        <MenuItem value="staff">Staff</MenuItem>
                        <MenuItem value="admin-assistant">Admin Assistant</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      size="small" label="Reason (optional)" value={assignForm.reason}
                      onChange={(e) => setAssignForm({ ...assignForm, reason: e.target.value })} sx={{ minWidth: 180 }}
                    />
                    <Button variant="contained" size="small" onClick={handleAssign} disabled={!assignForm.staffId || assigning} startIcon={<AssignmentIndIcon />}>
                      {assigning ? "Assigning..." : "Assign"}
                    </Button>
                    <Button size="small" onClick={() => setShowAssign(false)}>Cancel</Button>
                  </Box>
                </Box>
              )}

              {/* Escalation Log */}
              {showLog && (
                <Box sx={{ p: 2, background: "#fffde7", borderBottom: "1px solid #ffe082", maxHeight: 200, overflowY: "auto" }}>
                  <Typography variant="subtitle2" fontWeight={700} mb={1}>
                    <HistoryIcon fontSize="small" sx={{ mr: 0.5 }} /> Escalation Log
                  </Typography>
                  {!activeTicket.escalationLog?.length ? (
                    <Typography variant="body2" color="text.secondary">No escalations yet.</Typography>
                  ) : (
                    activeTicket.escalationLog.map((log, i) => (
                      <Box key={i} sx={{ fontSize: 12, mb: 1, pl: 1, borderLeft: "3px solid #ffc107" }}>
                        <b>{log.fromName}</b> → <b>{log.toName}</b>
                        <Typography variant="caption" display="block" color="text.secondary">
                          {log.reason || "N/A"} · {formatDate(log.escalatedAt)}
                        </Typography>
                      </Box>
                    ))
                  )}
                </Box>
              )}

              {/* Chat */}
              <TicketChat
                ticket={activeTicket}
                onMarkRead={markRead}
                onUpdate={(updated) => {
                  setActiveTicket(updated);
                  setTickets((prev) => prev.map((t) => (t._id === updated._id ? updated : t)));
                }}
              />
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default AdminHelpSupport;